// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../fontello/css/ehaclinics.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-600.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-600.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-600.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-600.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-700.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../public/fonts/Overpass/overpass-v10-latin-700.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../public/fonts/Asap/asap-v21-latin-italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../public/fonts/Asap/asap-v21-latin-italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../public/fonts/Asap/asap-v21-latin-italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../public/fonts/Asap/asap-v21-latin-italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../public/fonts/Asap/asap-v21-latin-italic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../public/img/bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../public/img/fallbackBg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Overpass" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#Overpass" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#Overpass" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#Asap" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overpass-regular - latin */
@font-face {
  font-family: Overpass;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: local(""), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
/* overpass-600 - latin */
@font-face {
  font-family: Overpass;
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: local(""), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
/* overpass-700 - latin */
@font-face {
  font-family: Overpass;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: local(""), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
/* asap-italic - latin */
@font-face {
  font-family: Asap;
  font-style: italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: local(""), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
html,
body {
  padding: 0;
  margin: 0;
  font-family: Overpass, sans-serif;
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media screen and (max-width: 1200px) {
  html,
  body {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  html,
  body {
    font-size: 13px;
  }
}

* {
  box-sizing: border-box;
}

b {
  font-weight: 600;
}

.clickable {
  cursor: pointer;
}

.link:hover {
  color: #41b5fd;
  cursor: pointer;
}

button {
  border: 0;
  background: 0;
  color: inherit;
}
button:disabled {
  opacity: 0.5;
}

.headline {
  font-size: 1.1rem;
  font-weight: 600;
}

.figure-xl {
  font-size: 1.8rem;
  font-weight: 600;
}

.badge {
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding-bottom: 0.2rem;
  padding-top: 0.3rem;
}
.badge.bg-light {
  color: #314342;
  font-weight: 400;
}

.circle {
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  background: #fcfdfd;
  border: 1px solid rgba(219, 233, 239, 0.5);
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  font-weight: 600;
}
.circle.circle-xs {
  width: 1.6rem;
  height: 1.6rem;
}

.label {
  font-family: Asap, sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 0.94rem;
}

.label-group {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 0.5rem;
  align-items: end;
}
.label-group .label {
  justify-self: end;
  margin-bottom: 0.1em;
}

.box {
  border-radius: 12px;
  background: white;
}

.text-box {
  border-radius: 4px;
  background: #f4f8f6;
  padding: 0.5em 0.5em 0.3em;
  margin-bottom: 0.5rem;
  display: inline-block;
}

.text-box-alert {
  background: rgba(244, 125, 130, 0.3);
}

.icon-list {
  list-style: none;
  padding-left: 0;
}
.icon-list li {
  display: flex;
  align-items: flex-start;
}

.main-bg-container {
  min-height: calc(100vh - 4rem);
  background: #f4f8f6;
  width: 100%;
}
.main-bg-container.fullscreen {
  min-height: 100vh;
}

@media screen and (min-width: 576px) and (max-width: 992px) {
  .modal-min-90 {
    max-width: 800px;
    width: 90vw;
  }
}

.modal-backdrop.front {
  z-index: 1055;
}

.filter-toggle input[type=checkbox] {
  position: absolute;
  left: -9999px;
}
.filter-toggle input[type=checkbox] + label {
  cursor: pointer;
  margin: 0;
  padding-right: 34px;
  position: relative;
  color: #6e7f80;
  width: 100%;
}
.filter-toggle input[type=checkbox] + label::before {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 1px;
  width: 26px;
  height: 16px;
  background-color: rgba(49, 67, 66, 0.2);
  box-shadow: 0 0 2px rgba(49, 67, 66, 0.2) inset;
  border-radius: 12px;
}
.filter-toggle input[type=checkbox] + label::after {
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  right: 1px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  transition: all 0.2s;
}
.filter-toggle input[type=checkbox]:checked + label {
  color: #314342;
}
.filter-toggle input[type=checkbox]:checked + label::before {
  background: #41b5fd;
}
.filter-toggle input[type=checkbox]:checked + label::after {
  background: #fff;
  right: 11px;
}

.card {
  border: none;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.1), 1px 1px 1px rgba(127, 139, 170, 0.2), 0 0 2px rgba(255, 255, 255, 0.3) inset;
  position: relative;
}
.card .label {
  color: #6e7f80;
}

.side-nav {
  width: 20%;
  min-width: 14rem;
  max-width: 16rem;
  border-right: 1px solid #dbe9ef;
}

.content {
  flex: 1 1;
}

.list-item {
  font-weight: 600;
  padding: 0.8rem 1rem;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  margin: 0.5rem 0;
  position: relative;
  transition: box-shadow 0.4s;
  display: flex;
  align-items: center;
}
.list-item::before {
  content: "";
  width: 1rem;
  height: 1rem;
  background: #fff;
  transform: rotate(-45deg);
  position: absolute;
  right: -0.4rem;
  top: calc(50% - 0.5rem);
  opacity: 0;
  transition: box-shadow 0.4s;
}
.list-item .side-nav-icon {
  margin-left: -2rem;
  position: absolute;
}
.list-item.active, .list-item:hover {
  background: #fff;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.1), 1px 1px 1px rgba(127, 139, 170, 0.2), 0 0 2px rgba(255, 255, 255, 0.3) inset;
  color: #41b5fd;
}
.list-item.active::before, .list-item:hover::before {
  box-shadow: 2px 2px 2px rgba(64, 83, 82, 0.1);
  opacity: 1;
}

.pointer {
  cursor: pointer;
}

.table-list {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: cover;
  min-height: calc(100vh - 4rem);
  padding-bottom: 4rem;
}
.table-list .table-list-header {
  background: #7f8baa;
  align-items: center;
}
.table-list .table-list-search {
  border-right: 1px solid #7f8baa;
  color: #fff;
}
.table-list .table-list-search input {
  background: none;
  border: 0;
  color: #fff;
  width: 100%;
  min-width: 10rem;
}
.table-list .table-list-search input:focus, .table-list .table-list-search input:focus-visible, .table-list .table-list-search input:active, .table-list .table-list-search input:hover {
  background: none;
  border: 0;
  outline: 0;
}
.table-list .table-list-search input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.table-list .table-list-filters {
  background: rgba(49, 67, 66, 0.1);
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border: 1px solid rgba(49, 67, 66, 0.1);
  flex: 1 1;
  border-radius: 2rem;
}
.table-list .eha-table td {
  border-bottom: 2px solid transparent;
}
.table-list .eha-table td:first-child {
  border-left: 0.5rem solid transparent;
}
.table-list .eha-table td:last-child {
  border-right: 0.5rem solid transparent;
}
.table-list .eha-table th:first-child {
  border-left: 0.5rem solid #7f8baa;
}
.table-list .eha-table th:last-child {
  border-right: 0.5rem solid #7f8baa;
}

.btn-primary {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.1), 1px 1px 1px rgba(127, 139, 170, 0.2), 0 0 2px rgba(255, 255, 255, 0.3) inset;
  padding-bottom: 0.4rem;
}
.btn-primary:focus, .btn-primary:hover, .btn-primary:active {
  color: #fff;
}
.btn-primary.pill {
  border-radius: 50rem;
}
.btn-primary.btn-sm {
  padding-bottom: 0.16em;
}
.btn-primary:disabled {
  color: #fff;
  background: #acbcbf;
  border-color: #acbcbf;
}
.btn-primary.loading {
  color: #c3d2d8;
  background: #fcfdfd;
  border-color: #dbe9ef;
  box-shadow: none;
}
.btn-primary.loading .loading-dots {
  position: relative;
  margin-right: 0.6rem;
  margin-left: -0.3rem;
  top: 0.15rem;
}

.btn-danger {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.1), 1px 1px 1px rgba(127, 139, 170, 0.2), 0 0 2px rgba(255, 255, 255, 0.3) inset;
  padding-bottom: 0.4rem;
}
.btn-danger:focus, .btn-danger:hover, .btn-danger:active {
  color: #fff;
}
.btn-danger.pill {
  border-radius: 50rem;
}
.btn-danger.btn-sm {
  padding-bottom: 0.16em;
}
.btn-danger:disabled {
  color: #fff;
  background: #acbcbf;
  border-color: #acbcbf;
}
.btn-danger.loading {
  color: #c3d2d8;
  background: #fcfdfd;
  border-color: #dbe9ef;
  box-shadow: none;
}
.btn-danger.loading .loading-dots {
  position: relative;
  margin-right: 0.6rem;
  margin-left: -0.3rem;
  top: 0.15rem;
}

.btn-link {
  text-transform: uppercase;
  letter-spacing: 0.03em;
  display: flex;
  align-items: center;
}

/* stylelint-disable */
.react-datepicker-popper .react-datepicker {
  background: #fff;
  box-shadow: 0 1px 4px rgba(49, 67, 66, 0.2), 0 1px 1px rgba(127, 139, 170, 0.2);
  border: 1px solid #dbe9ef;
  font-family: Overpass, sans-serif;
  font-size: 0.94rem;
  position: relative;
  display: flex;
}
.react-datepicker-popper .react-datepicker .react-datepicker__navigation {
  top: 1rem;
}
.react-datepicker-popper .react-datepicker .react-datepicker__header {
  background-color: #fcfdfd;
  border-bottom: 1px solid transparent;
  height: 5rem;
  padding: 0.8rem 0.5rem;
  display: flex;
  flex-direction: column;
}
.react-datepicker-popper .react-datepicker .react-datepicker__current-month,
.react-datepicker-popper .react-datepicker .react-datepicker-year-header {
  font-size: 1.4rem;
  font-weight: 300;
}
.react-datepicker-popper .react-datepicker .react-datepicker-time__header {
  margin-top: auto;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day-name {
  font-size: 0.7rem;
  text-transform: uppercase;
  color: #8b9dd6;
  width: 2rem;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day {
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.react-datepicker-popper .react-datepicker .react-datepicker__time-container {
  border-left: 1px solid #dbe9ef;
}
.react-datepicker-popper .react-datepicker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background: #41b5fd;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day--selected,
.react-datepicker-popper .react-datepicker .react-datepicker__day--in-selecting-range,
.react-datepicker-popper .react-datepicker .react-datepicker__day--in-range,
.react-datepicker-popper .react-datepicker .react-datepicker__month-text--selected,
.react-datepicker-popper .react-datepicker .react-datepicker__month-text--in-selecting-range,
.react-datepicker-popper .react-datepicker .react-datepicker__month-text--in-range,
.react-datepicker-popper .react-datepicker .react-datepicker__quarter-text--selected,
.react-datepicker-popper .react-datepicker .react-datepicker__quarter-text--in-selecting-range,
.react-datepicker-popper .react-datepicker .react-datepicker__quarter-text--in-range,
.react-datepicker-popper .react-datepicker .react-datepicker__year-text--selected,
.react-datepicker-popper .react-datepicker .react-datepicker__year-text--in-selecting-range,
.react-datepicker-popper .react-datepicker .react-datepicker__year-text--in-range {
  background: #41b5fd;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day--keyboard-selected,
.react-datepicker-popper .react-datepicker .react-datepicker__month-text--keyboard-selected,
.react-datepicker-popper .react-datepicker .react-datepicker__quarter-text--keyboard-selected,
.react-datepicker-popper .react-datepicker .react-datepicker__year-text--keyboard-selected {
  background: #5b74c6;
}
.react-datepicker-popper .react-datepicker .react-datepicker__year-read-view--down-arrow,
.react-datepicker-popper .react-datepicker .react-datepicker__month-read-view--down-arrow,
.react-datepicker-popper .react-datepicker .react-datepicker__month-year-read-view--down-arrow,
.react-datepicker-popper .react-datepicker .react-datepicker__navigation-icon::before {
  border-color: #41b5fd;
  border-width: 2px 2px 0 0;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker .react-datepicker__triangle::before {
  border-bottom-color: #dbe9ef;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker .react-datepicker__triangle::after {
  border-bottom-color: #fcfdfd;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker .react-datepicker__triangle::before {
  border-top-color: #c3d2d8;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker .react-datepicker__triangle::after {
  border-bottom-color: #fff;
}

.react-datepicker-wrapper .react-datepicker__close-icon::after {
  background: none;
  font-size: 1.4rem;
}

.react-datepicker__input-container input {
  width: 100%;
  padding: 0.6rem 1rem 0.4rem;
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border-radius: 4px;
  background: rgba(65, 181, 253, 0.2);
  border: 1px solid transparent;
  margin-bottom: 1px;
}
.react-datepicker__input-container input.date-filter {
  background: rgb(136.1943661972, 147.3323943662, 176.1056338028);
  color: #fff;
  box-shadow: 1px 1px 1px rgba(64, 83, 82, 0.2);
}
.react-datepicker__input-container input.date-filter::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.react-datepicker__input-container input:focus-within, .react-datepicker__input-container input:focus-visible {
  background: rgba(65, 181, 253, 0.3);
  border: 1px solid rgba(65, 181, 253, 0.3);
  outline: none;
}
.react-datepicker__input-container input:hover {
  background: rgba(65, 181, 253, 0.3);
}

/* stylelint-enable */
.eha-topnav {
  height: 4rem;
  box-shadow: 0 1px 4px rgba(49, 67, 66, 0.2), 0 1px 1px rgba(127, 139, 170, 0.2);
}
.eha-topnav .navbar-brand {
  line-height: 0;
  height: 3rem;
}
.eha-topnav .nav-link {
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.eha-topnav .user-name .nav-link {
  text-transform: none;
  letter-spacing: 0;
  color: #fff;
  font-size: 1rem;
}
.eha-topnav .user-name .nav-link::before {
  font-family: ehaclinics, sans-serif;
  display: inline-block;
  width: 1em;
  margin-right: 0.5em;
  text-align: center;
  content: "\\e805";
}
.eha-topnav .navbar-collapse.collapse,
.eha-topnav .navbar-collapse.collapsing {
  background: #405352;
  padding: 0.5rem 1rem 0;
}

.eha-topnav ~ .main {
  margin-top: 4rem;
}

.bookmarks {
  position: fixed;
  bottom: 0;
  background: #7f8baa;
  width: 100vw;
  display: flex;
  padding: 0 0.5rem;
}

.bookmark {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  flex: 1 1 auto;
  background: #fff;
  color: #314342;
  border-radius: 6px 6px 0 0;
  padding: 0.2rem 0;
  margin: 0.75rem 0.2rem 0;
  width: 10%;
  max-width: 16rem;
}
.bookmark .bookmark-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* stylelint-disable */
.select.select-dark {
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border-radius: 4px;
  padding: 0rem;
  background: rgba(65, 181, 253, 0.2);
  border: 1px solid transparent;
}
.select.select-filter {
  background: rgb(136.1943661972, 147.3323943662, 176.1056338028);
  box-shadow: 1px 1px 1px rgba(64, 83, 82, 0.2);
  border-radius: 4px;
}
.select.select-filter .select__value-container {
  padding: 0.5rem 0 0.4rem 1rem;
}
.select.select-filter .select__single-value,
.select.select-filter .select__input-container {
  color: #fff;
}
.select.select-filter .select__indicator-separator {
  background: rgba(255, 255, 255, 0.2);
}
.select.select-filter .select__indicator,
.select.select-filter .select__indicator:hover {
  color: #fff;
}
.select.select-filter .select__placeholder {
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select.select-filter .select__placeholder::before {
  display: none;
}
.select .select__control {
  border: 0;
  background: 0;
  box-shadow: none;
  height: auto;
}
.select .select__value-container {
  padding: 1rem 1.2rem 0.8rem;
}
.select .select__value-container--has-value.select__value-container--is-multi {
  padding-left: 1rem;
}
.select .select__input-container {
  padding: 0;
  margin: 0;
}
.select .select__input {
  margin: 0;
}
.select .select__placeholder::before {
  content: "";
  display: block;
  width: 1rem;
  height: 1px;
  border-bottom: 1px solid #41b5fd;
  position: absolute;
  left: 1.2rem;
  bottom: 1rem;
}
.select .select__multi-value {
  background: #dbe9ef;
}
.select .select__indicator,
.select .select__indicator:hover {
  color: #41b5fd;
}
.select .select__menu {
  margin-top: 1px;
}
.select .select__option--is-selected {
  background: #41b5fd;
}

/* stylelint-enable */
.form-group {
  background: rgba(219, 233, 239, 0.2);
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border-radius: 4px;
  padding: 0 0.6rem;
  position: relative;
  margin-bottom: 1rem;
}
.form-group .input-wrapper,
.form-group .select-wrapper {
  position: relative;
}
.form-group .input-wrapper.empty::before,
.form-group .select-wrapper.empty::before {
  content: "";
  display: block;
  width: 1rem;
  height: 1px;
  border-bottom: 1px solid #41b5fd;
  position: absolute;
  left: 1.2rem;
  bottom: 1rem;
}
.form-group:focus-within {
  background: rgba(219, 233, 239, 0.4);
  border: 1px solid rgba(219, 233, 239, 0.6);
  /* stylelint-disable */
}
.form-group:focus-within .input-wrapper::before,
.form-group:focus-within .select__placeholder {
  display: none;
}
.form-group:focus-within {
  /* stylelint-enable */
}
.form-group:hover {
  background: rgba(219, 233, 239, 0.4);
}
.form-group.required {
  background: rgba(65, 181, 253, 0.1);
}
.form-group.required label::after {
  content: "*";
  font-size: 1.6rem;
  position: absolute;
  margin-left: 0.2rem;
  top: -0.1rem;
}
.form-group.required:focus-within {
  background: rgba(65, 181, 253, 0.2);
  border: 1px solid #dbe9ef;
}
.form-group.required:hover {
  background: rgba(65, 181, 253, 0.2);
}
.form-group.error {
  background: rgba(244, 125, 130, 0.1);
  border: 1px solid rgba(244, 125, 130, 0.15);
}
.form-group.error:focus-within {
  background: rgba(244, 125, 130, 0.15);
  border: 1px solid rgba(244, 125, 130, 0.2);
}
.form-group.error:hover {
  background: rgba(244, 125, 130, 0.15);
}
.form-group.form-group-dark {
  background: rgba(65, 181, 253, 0.2);
  border: 1px solid transparent;
}
.form-group.form-group-dark:focus-within {
  background: rgba(65, 181, 253, 0.3);
  border: 1px solid rgba(65, 181, 253, 0.3);
}
.form-group.form-group-dark:hover {
  background: rgba(65, 181, 253, 0.3);
}
.form-group label {
  display: block;
  font-family: Asap, sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 0.94rem;
  padding: 5px;
  color: black;
  margin: 0.4rem 0 0;
}
.form-group .form-text {
  margin: 0.2rem 0 0;
}
.form-group input,
.form-group textarea {
  padding: 1rem 1.2rem 0.8rem;
}
.form-group select {
  padding: 1rem 1.2rem 0.8rem 1rem;
}
.form-group input,
.form-group select,
.form-group textarea {
  border: 0;
  background: none;
  color: black;
  width: 100%;
  border-radius: 4px;
}
.form-group input:active, .form-group input:focus, .form-group input:focus-within, .form-group input:focus-visible,
.form-group select:active,
.form-group select:focus,
.form-group select:focus-within,
.form-group select:focus-visible,
.form-group textarea:active,
.form-group textarea:focus,
.form-group textarea:focus-within,
.form-group textarea:focus-visible {
  border: 0;
  outline: 0;
}

.form-group-multi {
  background: rgba(219, 233, 239, 0.2);
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border: 1px solid rgba(219, 233, 239, 0.3);
  border-radius: 4px;
  position: relative;
}
.form-group-multi .form-group {
  background: none;
  box-shadow: none;
  border: 1px solid transparent;
  margin: 0;
  padding: 0.1rem 0.6rem;
}
.form-group-multi .form-group .input-wrapper.empty::after {
  content: "";
  display: block;
  width: calc(100% - 3.7rem);
  height: 1px;
  border-bottom: 1px solid #dbe9ef;
  position: absolute;
  left: 2.5rem;
  bottom: 1rem;
}
.form-group-multi .form-group:hover, .form-group-multi .form-group:focus-within {
  background: rgba(219, 233, 239, 0.2);
}
.form-group-multi .form-group:focus-within .input-wrapper.empty::after {
  display: none;
}
.form-group-multi .form-group.required {
  border: 1px solid transparent;
}
.form-group-multi .row {
  margin: 0;
}
.form-group-multi .row > div {
  padding: 0;
  display: flex;
}

/* stylelint-disable */
.form-group .PhoneInputCountry {
  left: 1.2rem;
}
.form-group .PhoneInputCountryIconImg {
  border-radius: 2px;
}
.form-group .PhoneInputCountryIcon {
  border-radius: 2px;
  box-shadow: 0 0 2px #acbcbf;
}

/* stylelint-enable */
.delete-button {
  position: relative;
  display: inline-block;
}
.delete-button .confirmation-dialog {
  z-index: 100;
  text-align: left;
  position: absolute;
  bottom: -1rem;
  right: 0px;
  background: #fff;
  width: 19rem;
  padding: 0.8rem 1rem 1rem;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.2), 1px 1px 2px rgba(127, 139, 170, 0.2);
}
.delete-button .confirmation-dialog input {
  padding: 0.5rem;
}
.delete-button .small {
  text-transform: capitalize !important;
}

.branch-search {
  position: relative;
  padding: 0;
  min-width: 16rem;
  flex: 1 1;
}
.branch-search .branch-dropdown {
  position: absolute;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(49, 67, 66, 0.2), 0 1px 1px rgba(127, 139, 170, 0.2);
  background: white;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: 100;
}
.branch-search .dropdown-items {
  overflow-y: auto;
  max-height: 60vh;
}
.branch-search .branch-dropdown-item {
  padding: 0.5rem;
  font-size: 0.94rem;
}
.branch-search .branch-dropdown-item .label {
  color: #8d9da0;
}
.branch-search .branch-dropdown-item:hover {
  background: #f4f8f6;
  cursor: pointer;
}
.branch-search .branch-dropdown-item:not(:last-child) {
  border-bottom: 1px solid #dbe9ef;
}

.selected-branches-details {
  border: 1px solid red;
}

/* stylelint-disable */
@keyframes scaledown {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  30% {
    opacity: 1;
  }
  80% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
@keyframes scaleup {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  10% {
    opacity: 1;
  }
  70% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
/* stylelint-enable */
.loading-spinner {
  width: 3rem;
  height: 3rem;
  position: relative;
  display: inline-block;
}
.loading-spinner .circle1,
.loading-spinner .circle2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: #41b5fd;
  animation: scaledown 2.8s infinite;
}
.loading-spinner .circle2 {
  background: #5b74c6;
  transform: scale(0);
  animation: scaleup 2.8s infinite;
  animation-delay: 0.8s;
}
.loading-spinner.sm {
  width: 1rem;
  height: 1rem;
}

.loading-dots .loading-spinner:nth-of-type(2) .circle1 {
  animation-delay: 0.4s;
}
.loading-dots .loading-spinner:nth-of-type(2) .circle2 {
  animation-delay: 1.2s;
}
.loading-dots .loading-spinner:nth-of-type(3) .circle1 {
  animation-delay: 0.8s;
}
.loading-dots .loading-spinner:nth-of-type(3) .circle2 {
  animation-delay: 1.6s;
}

.bar-placeholder,
.circle-placeholder {
  background: rgba(219, 233, 239, 0.5);
  width: 100%;
  height: 1rem;
  border-radius: 4px;
  margin: 0.5rem 0;
}
.bar-placeholder.white,
.circle-placeholder.white {
  background: rgba(255, 255, 255, 0.4);
}

.circle-placeholder {
  width: 6rem;
  height: 6rem;
  border-radius: 100%;
  margin: 0.5rem;
}

.loading-placeholder .bar-placeholder {
  height: 3rem;
}
.loading-placeholder .bar-placeholder:first-child {
  margin-right: 1rem;
}

.eha-table {
  width: 100%;
}
.eha-table thead,
.eha-table tbody {
  width: 100%;
  padding: 1rem 1.5rem;
}
.eha-table thead {
  background: #7f8baa;
  color: white;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.1), 1px 1px 1px rgba(127, 139, 170, 0.2), 0 0 2px rgba(255, 255, 255, 0.3) inset;
  z-index: 1;
  padding: 0.5rem 1.5rem;
}
.eha-table tbody tr {
  background: white;
  margin-top: 2px;
  border-radius: 4px;
}
.eha-table th,
.eha-table td {
  padding: 0.7rem 0.8rem 0.5rem;
  white-space: nowrap;
}
.eha-table td {
  white-space: nowrap;
  overflow: hidden;
  vertical-align: baseline;
}
.eha-table td:not(:last-child) {
  text-overflow: ellipsis;
}
.eha-table th {
  font-family: Asap, sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
}
.eha-table td.name {
  font-weight: 600;
}
.eha-table td.age {
  font-weight: 600;
}
.eha-table td.age span {
  margin-left: 0.2em;
  color: #6e7f80;
  font-weight: 400;
}

.pagination-bar {
  background: #7f8baa;
  color: white;
  padding: 0.7rem 1.5rem 0.5rem;
}

.dropdown.action-menu .dropdown-toggle {
  background: #fcfdfd;
  color: #41b5fd;
  border: 0;
  border-radius: 2rem;
  font-size: 1.5rem;
  padding: 0.2rem 0.5rem;
  line-height: 0;
}
.dropdown.action-menu .dropdown-toggle::after {
  display: none;
}
.dropdown.action-menu .dropdown-toggle .dropdown-menu {
  margin-top: 0.2rem;
}
.dropdown.action-menu.small .dropdown-toggle {
  font-size: 1.1rem;
  padding: 0.2rem;
}

.ca-main {
  width: 100%;
  position: relative;
}
.ca-main.update-page {
  min-height: calc(100vh - 56px);
  margin-top: 56px;
  padding: 30px 20px 20px 20px;
}
.ca-main.update-modal {
  min-height: 100vh;
}

.ca-body {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.ca-header {
  background-color: #41b5fd;
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: white;
}

.ca-header-column {
  display: flex;
  flex-direction: column;
  row-gap: 6px;
}

.view-details {
  text-decoration: underline;
}

.ca-header-title {
  font-size: 22px;
  color: white;
  font-weight: 600;
}

.ca-timing {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 20px;
}

.ca-timing-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 3px;
  color: white;
  font-size: 13px;
  font-family: Asap, sans-serif;
}

.ca-info {
  width: 100%;
  padding: 30px 20px;
}

.ca-grid {
  width: 800px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 13px;
}

.ca-grid-item {
  display: flex;
  flex-direction: column;
  color: #405352;
}

.ca-grid-item-label {
  font-size: 13px;
  font-family: Asap, sans-serif;
}

.ca-grid-item-text {
  font-size: 16px;
  font-weight: 600;
}

.ca-reason-section {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.ca-textarea-reason {
  width: 100%;
  padding: 5px;
  background: transparent;
  box-shadow: none;
  border: none;
  outline: none;
}

.ca-buttons-section {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.ca-buttons {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

.ca-button {
  color: white;
}
.ca-button:hover {
  color: white;
}
.ca-button:focus {
  color: white;
}

.ca-button2 {
  background-color: #c3d2d8;
}

.ca-modal-main .modal-min-90 {
  width: 500px !important;
}
.ca-modal-main .modal-min-180 {
  width: 100vw !important;
}

.ca-exit {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.ca-exit .eha-close {
  color: #41b5fd;
}

.cancel-exit .eha-close {
  color: #6e7f80;
  font-size: 17px;
}

.ca-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 20px;
  padding: 0px 20px;
}

.ca-calendar-x {
  position: relative;
}
.ca-calendar-x .eha-calendar-empty {
  font-size: 35px;
}
.ca-calendar-x .ca-x-icon {
  position: absolute;
  top: 17px;
  left: 19px;
  color: #f47d82;
}

.ca-modal-title {
  font-size: 20px;
  font-weight: 600;
}

.ca-note {
  width: 100%;
  text-align: center;
}

.ca-note-booking {
  margin-bottom: 20px;
}

.update-booking-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 30px;
}

.update-booking-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0px;
  background: rgba(219, 233, 239, 0.2);
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border: 1px solid rgba(219, 233, 239, 0.3);
  border-radius: 4px;
}
.update-booking-card .title-desc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.update-booking-card .card-desc {
  width: 450px;
  text-align: center;
  color: #6e7f80;
}
.update-booking-card button {
  margin-top: 20px;
  color: white;
}
.update-booking-card button:hover {
  color: white;
}
.update-booking-card button:active {
  color: white;
}

.loading-booking {
  width: 100%;
  height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  display: flex;
  align-items: center;
  justify-content: center;
}

.update-modal-main {
  width: 100%;
}
.update-modal-main .modal-xl {
  min-width: 97% !important;
  max-width: 97% !important;
}
.update-modal-main .modal-header {
  padding: 5px 2px;
}

.update-modal-main-body {
  overflow-y: scroll;
}

@media screen and (max-width: 1000px) {
  .ca-grid {
    width: 100%;
  }
  .ca-note {
    width: 100%;
  }
  .ca-modal-main {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .update-booking-card {
    padding: 40px 10px;
  }
  .update-booking-card .card-desc {
    width: 100%;
  }
}
@media screen and (max-width: 550px) {
  .ca-grid {
    grid-template-columns: 1fr;
  }
  .update-booking-cards {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
  .ca-modal-main {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ca-modal-main .modal-min-90 {
    width: 340px !important;
  }
  .ca-modal-main .modal-dialog-centered {
    margin: auto;
  }
  .ca-modal {
    padding: 0px 10px;
  }
}
.provider-schedule-section {
  margin-top: 50px;
  width: 100%;
  max-width: 100%;
}

.provider-schedule-card {
  border: none;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 6px rgba(64, 83, 82, 0.1), 1px 1px 1px rgba(127, 139, 170, 0.2), 0 0 2px rgba(255, 255, 255, 0.3) inset;
  position: relative;
  padding: 20px 15px;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}

.provider-schedule-title {
  font-size: 12px;
  flex: 1 1;
}

.provider-schedule-main {
  width: 100%;
}

.provider-grid-section {
  width: 100%;
  padding: 20px 25px 20px 0px;
}

.header-row {
  display: grid;
  grid-template-columns: 2fr 10fr;
  width: 100%;
  max-width: 100%;
  height: 30px;
}

.header-time-labels {
  display: flex;
  position: relative;
}

.header-time-label {
  display: block;
  font-weight: 400;
  font-size: 11px;
  position: absolute;
  bottom: 0;
}

.slider-body-row {
  display: grid;
  grid-template-columns: 2fr 10fr;
  width: 100%;
  height: 45px;
}

.slider-body-cells {
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  padding: 0 !important;
  position: relative;
  z-index: 0;
}

.slider-day-switch {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.actual-slider-day-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
}

.slider-day-name {
  font-size: 11px;
  font-weight: 400;
  font-family: Asap, sans-serif;
}

.time-range-tag1 {
  position: absolute;
  bottom: 15%;
  font-size: 12px;
  font-weight: 400;
  background-color: transparent;
}

.slider-body-cell {
  border-right: 0.5px solid #ecf5f7;
}

.slider-body-cell:nth-child(3) {
  border-left: 0.5px solid #ecf5f7;
}

.slider-body {
  width: 100%;
  position: absolute;
  bottom: 0;
}

.range-slider {
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #ebeff0;
  height: 10px;
  align-items: center;
}

.center-slider {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.slider-unavailable {
  font-size: 10px;
}

.booking-fallback {
  min-height: calc(100vh - 56px);
  width: 100%;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-size: cover;
  position: relative;
}

.booking-error-text {
  position: absolute;
  top: 18%;
  left: 15%;
  font-size: 220px;
  font-weight: 600;
  color: white;
}

.booking-error-image-footer {
  position: absolute;
  right: 15%;
  top: 26%;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  align-items: center;
}
.booking-error-image-footer div {
  font-size: 20px;
  color: white;
  font-weight: 600;
}

@media screen and (max-width: 1150px) {
  .booking-error-text {
    font-size: 160px;
    left: 100px;
  }
  .booking-error-image-footer {
    right: 100px;
  }
  .booking-error-image-footer img {
    width: 200px;
  }
}
@media screen and (max-width: 850px) {
  .booking-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .booking-error-text {
    position: relative;
    font-size: 80px;
    left: 0;
  }
  .booking-error-image-footer {
    position: relative;
    right: 0;
  }
  .booking-error-image-footer img {
    width: 160px;
  }
}
.rtb-toolbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
}

.rtb-toolbar-top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
}

.rtb-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.rtb-cal-btn {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  padding: 2px;
  color: rgb(76, 117, 121);
}

.rbc-btn {
  margin-left: 10px !important;
  padding: 2px 5px;
  background-color: transparent;
  cursor: pointer;
  font-size: 11px !important;
}

.rbc-btn.active {
  background-color: #2b8ef8;
  color: white;
  border-radius: 8px;
  padding: 0 15px;
}

.rtb-nav-button {
  border: none !important;
  background: none !important;
  cursor: pointer;
  font-size: 11px;
  padding: 5px;
  outline: none !important;
  box-shadow: none !important;
  color: #2b8ef8 !important;
}

.rtb-nav-icon {
  font-size: 16px !important;
  margin: 0 3px;
}

.rtb-toolbar-label {
  font-weight: bold;
  font-size: 14px;
  padding: 0 10px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-save {
  margin-left: 20px;
}

.rbc-header {
  background: rgba(126, 195, 204, 0.1725490196);
  padding: 20px !important;
  font-size: 18px !important;
}

.rbc-allday-cell {
  display: none;
}

.rbc-event {
  background-color: transparent !important;
  height: 100px;
}

.custom-event {
  border-right: 0px !important;
  border-left: 4px;
  border-top: 0px !important;
  border-bottom: 0 !important;
  padding: 8px 8px;
  padding-left: 6px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.shift-time {
  font-size: 0.9rem;
  font-weight: bold;
  width: 100%;
  text-align: left;
}

.shift-title {
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  text-align: left;
}

.custom-modal-size {
  max-width: 99%;
}

.modal-title {
  font-size: 20px;
  margin-top: 5px;
  color: rgba(78, 76, 76, 0.836);
}

.toggle-container {
  border-bottom: 1px solid rgba(126, 195, 204, 0.1725490196);
  padding: 8px 20px;
  color: rgba(78, 76, 76, 0.836);
}

.toggle-button {
  justify-content: left;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
}

.toggle {
  background-color: #2b8ef8;
  height: 9px;
  width: 20px;
  border-radius: 30px;
  display: flex;
}

.toggle-active {
  background-color: rgba(98, 133, 136, 0.836);
}

.toggle-left {
  height: 7px;
  width: 5px;
  background-color: white;
  border-radius: 20px;
  margin: 1.5px 2px;
}

.toggle-right {
  height: 7px;
  width: 5px;
  background-color: white;
  border-radius: 20px;
  margin: 1px 0.5px 2px 12.5px;
}

.toggle-button2 {
  justify-content: left;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.toggle2 {
  background-color: #2b8ef8;
  height: 9px;
  width: 20px;
  border-radius: 30px;
  display: flex;
}

.toggle-left2 {
  height: 7px;
  width: 5px;
  background-color: white;
  border-radius: 20px;
  margin: 1px 2px;
}

.toggle-right2 {
  height: 7px;
  width: 5px;
  background-color: white;
  border-radius: 20px;
  margin: 1px 0.5px 2px 12.5px;
}

.toggle-active2 {
  background-color: rgba(98, 133, 136, 0.836);
}

.menu-container {
  position: fixed;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
}

.menu-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  border-bottom: 1px solid #ddd;
}

.selected-date {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.close-menu {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: transparent;
  font-size: 16px;
  cursor: pointer;
}

.close-menu:hover {
  color: #ff0000;
}

select {
  width: 100%;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  font-size: 14px;
}

.hidden-day {
  display: none !important;
}

.all-day-label input {
  margin-right: 4px;
}

.bold-text {
  font-weight: bold;
  font-size: 16px;
  color: #415EBC;
}

.cancel-button {
  border-color: #415EBC;
  color: #415EBC;
}

.booking-header {
  padding: 4px 20px 12px 24px;
}

.booking-divider {
  height: 1px;
  background-color: #e7f0f2;
}

.client-table-appointment .center-alert {
  height: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
}
.client-table-appointment .center-search {
  position: absolute;
  width: 100%;
  top: 55%;
}

.collapsible-filterbar {
  background: rgba(49, 67, 66, 0.1);
  box-shadow: 1px 1px 6px rgba(64, 83, 82, 0.06) inset;
  border: 1px solid rgba(49, 67, 66, 0.1);
  flex: 1 1;
  border-radius: 1.8rem;
}
.collapsible-filterbar .filters-top {
  color: #fff;
}
.collapsible-filterbar .filterbar-toggle {
  width: 4rem;
  margin-left: 1px;
  cursor: pointer;
  border-top-right-radius: 1.8rem;
}
.collapsible-filterbar .filterbar-toggle:hover {
  background: rgba(91, 116, 198, 0.2);
}
.collapsible-filterbar .filterbar-search input {
  background: none;
  border: 0;
  color: #fff;
  flex: 1 1;
  padding-right: 1.6rem;
}
.collapsible-filterbar .filterbar-search input:focus, .collapsible-filterbar .filterbar-search input:focus-visible, .collapsible-filterbar .filterbar-search input:active, .collapsible-filterbar .filterbar-search input:hover {
  background: none;
  border: 0;
  outline: 0;
}
.collapsible-filterbar .filterbar-search input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.collapsible-filterbar .filters-expand {
  background: rgba(49, 67, 66, 0.1);
  border-bottom-right-radius: 1.8rem;
  border-bottom-left-radius: 1.8rem;
}
.collapsible-filterbar.collapsed .filters-expand {
  display: none;
}
.collapsible-filterbar.collapsed .filterbar-toggle {
  border-bottom-right-radius: 1.8rem;
}

.filter-badge {
  font-size: 0.9rem;
  color: #dbe9ef;
  border-radius: 4px;
  /* stylelint-disable */
  background: rgb(136.1943661972, 147.3323943662, 176.1056338028);
  /* stylelint-enable */
  padding: 0.1rem 0.8rem;
  margin: 0.1rem 0 0.1rem 0.6rem;
}

.input-switch {
  position: relative;
  align-items: center;
  flex: 1 1;
}

.filter-reset-value {
  opacity: 0.4;
  position: absolute;
  right: 1.6rem;
}
.filter-reset-value:hover {
  opacity: 0.7;
}

.search-menu .search-toggle {
  color: #fff;
}

.redBorder {
  border: 1px solid red;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/styles/index.scss","webpack://./src/styles/globals.scss","webpack://./src/styles/bootstrap-variables.scss","webpack://./src/styles/button.scss","webpack://./src/styles/datepicker.scss","webpack://./src/components/layout/_layout.scss","webpack://./src/components/form/_form.scss","webpack://./src/components/branches/_branches.scss","webpack://./src/components/loading/_loading.scss","webpack://./src/components/table/_table.scss","webpack://./src/components/action-menu/_actionMenu.scss","webpack://./src/components/update-booking/_cancel.scss","webpack://./src/components/service-providers/_serviceProviderSchedule.scss","webpack://./src/components/update-booking/_bookingFallback.scss","webpack://./src/components/service-providers/_providerCalendar.scss","webpack://./src/components/booking-list/_bookings.scss","webpack://./src/components/clients/_clients.scss"],"names":[],"mappings":"AAAA,6BAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA,EAAA,qBAAA;EACA,uTAEE,EAK0F,eAAA;ACL9F;ADQA,yBAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA,EAAA,qBAAA;EACA,yTAEE,EAKsF,eAAA;ACb1F;ADgBA,yBAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA,EAAA,qBAAA;EACA,4TAEE,EAKsF,eAAA;ACrB1F;ADwBA,wBAAA;AACA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA,EAAA,qBAAA;EACA,4TAEE,EAK6E,eAAA;AC7BjF;ACvBA;;EAEE,UAAA;EACA,SAAA;EACA,iCAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;ADyBF;ACvBE;EATF;;IAUI,eAAA;ED2BF;AACF;ACzBE;EAbF;;IAcI,eAAA;ED6BF;AACF;;AC1BA;EACE,sBAAA;AD6BF;;AC1BA;EACE,gBAAA;AD6BF;;AC1BA;EACE,eAAA;AD6BF;;AC1BA;EACE,cCtBK;EDuBL,eAAA;AD6BF;;AC1BA;EACE,SAAA;EACA,aAAA;EACA,cAAA;AD6BF;AC3BE;EACE,YAAA;AD6BJ;;ACzBA;EACE,iBAAA;EACA,gBAAA;AD4BF;;ACzBA;EACE,iBAAA;EACA,gBAAA;AD4BF;;ACzBA;EACE,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AD4BF;AC1BE;EACE,cCxDS;EDyDT,gBAAA;AD4BJ;;ACxBA;EACE,oDCOiB;EDNjB,mBCzES;ED0ET,0CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;AD2BF;ACzBE;EACE,aAAA;EACA,cAAA;AD2BJ;;ACvBA;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AD0BF;;ACvBA;EACE,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AD0BF;ACxBE;EACE,iBAAA;EACA,oBAAA;AD0BJ;;ACtBA;EACE,mBCvDiB;EDwDjB,iBAAA;ADyBF;;ACtBA;EACE,kBC7DiB;ED8DjB,mBCpHS;EDqHT,0BAAA;EACA,qBAAA;EACA,qBAAA;ADyBF;;ACtBA;EACE,oCAAA;ADyBF;;ACtBA;EACE,gBAAA;EACA,eAAA;ADyBF;ACvBE;EACE,aAAA;EACA,uBAAA;ADyBJ;;ACrBA;EACE,8BAAA;EACA,mBC1IS;ED2IT,WAAA;ADwBF;ACtBE;EACE,iBAAA;ADwBJ;;ACnBE;EADF;IAEI,gBAAA;IACA,WAAA;EDuBF;AACF;;ACpBA;EACE,aAAA;ADuBF;;ACnBE;EACE,kBAAA;EACA,aAAA;ADsBJ;ACnBE;EACE,eAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cClKO;EDmKP,WAAA;ADqBJ;ACnBI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,+CAAA;EACA,mBAAA;ADqBN;AClBI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBCnME;EDoMF,oBAAA;ADoBN;AChBE;EACE,cC9LS;AFgNb;AChBI;EACE,mBC9LC;AFgNP;ACfI;EACE,gBChNE;EDiNF,WAAA;ADiBN;;ACZA;EACE,YAAA;EACA,mBC/JiB;EDgKjB,gBCzNM;ED0NN,uHC7IW;ED8IX,kBAAA;ADeF;ACbE;EACE,cCtNO;AFqOX;;ACXA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;ADcF;;ACXA;EACE,SAAA;ADcF;;ACXA;EACE,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,mBCxLiB;EDyLjB,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;ADcF;ACZE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBC5PI;ED6PJ,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;EACA,2BAAA;ADcJ;ACXE;EACE,kBAAA;EACA,kBAAA;ADaJ;ACVE;EAEE,gBC5QI;ED6QJ,uHChMS;EDiMT,cChQG;AF2QP;ACTI;EACE,6CAAA;EACA,UAAA;ADWN;;ACPA;EACE,eAAA;ADUF;;ACRA;EACE,yDAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;ADWF;ACTE;EACE,mBChRK;EDiRL,mBAAA;ADWJ;ACRE;EACE,+BAAA;EACA,WCtSI;AFgTR;ACRI;EACE,gBAAA;EACA,SAAA;EACA,WC3SE;ED4SF,WAAA;EACA,gBAAA;ADUN;ACRM;EAIE,gBAAA;EACA,SAAA;EACA,UAAA;ADOR;ACHI;EACE,+BAAA;ADKN;ACDE;EACE,iCAAA;EACA,oDChPe;EDiPf,uCAAA;EACA,SAAA;EACA,mBAAA;ADGJ;ACCI;EACE,oCAAA;ADCN;ACCM;EACE,qCAAA;ADCR;ACEM;EACE,sCAAA;ADAR;ACKM;EACE,iCAAA;ADHR;ACMM;EACE,kCAAA;ADJR;;AGzVA;EACE,WDGM;ECFN,yBAAA;EACA,sBAAA;EACA,uHD6EW;EC5EX,sBAAA;AH4VF;AG1VE;EAGE,WDNI;AFgWR;AGvVE;EACE,oBAAA;AHyVJ;AGtVE;EACE,sBAAA;AHwVJ;AGrVE;EACE,WDlBI;ECmBJ,mBDbO;ECcP,qBDdO;AFqWX;AGpVE;EACE,cDnBO;ECoBP,mBDxBO;ECyBP,qBDtBO;ECuBP,gBAAA;AHsVJ;AGpVI;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;AHsVN;;AGjVA;EACE,WDvCM;ECwCN,yBAAA;EACA,sBAAA;EACA,uHDmCW;EClCX,sBAAA;AHoVF;AGlVE;EAGE,WDhDI;AFkYR;AG/UE;EACE,oBAAA;AHiVJ;AG9UE;EACE,sBAAA;AHgVJ;AG7UE;EACE,WD5DI;EC6DJ,mBDvDO;ECwDP,qBDxDO;AFuYX;AG5UE;EACE,cD7DO;EC8DP,mBDlEO;ECmEP,qBDhEO;ECiEP,gBAAA;AH8UJ;AG5UI;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;AH8UN;;AGzUA;EACE,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AH4UF;;AIpaA,sBAAA;AAEA;EACC,gBFCO;EEAP,+EAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACC,aAAA;AJsaF;AIpaE;EACE,SAAA;AJsaJ;AInaC;EACE,yBFXQ;EEYP,oCAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AJqaJ;AIlaE;;EAEE,iBAAA;EACA,gBAAA;AJoaJ;AIjaE;EACE,gBAAA;AJmaJ;AIhaE;EACE,iBAAA;EACA,yBAAA;EACA,cFLc;EEMd,WAAA;AJkaJ;AI/ZE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AJiaJ;AI9ZE;EACE,8BAAA;AJgaJ;AI7ZE;EACE,mBFtCG;AFqcP;AI5ZE;;;;;;;;;;;;EAYE,mBFrDG;AFmdP;AI3ZE;;;;EAIE,mBF3DK;AFwdT;AI1ZE;;;;EAIE,qBFnEG;EEoEH,yBAAA;AJ4ZJ;;AIxZA;EACE,4BFnFS;AF8eX;;AIxZA;EACE,4BF1FS;AFqfX;;AIxZA;EACE,yBF1FS;AFqfX;;AIxZA;EACE,yBFnGM;AF8fR;;AIxZA;EACE,gBAAA;EACA,iBAAA;AJ2ZF;;AIxZA;EACC,WAAA;EACA,2BAAA;EACA,oDF9BkB;EE+BjB,kBFvDiB;EEwDjB,mCAAA;EACA,6BAAA;EACA,kBAAA;AJ2ZF;AIzZE;EACE,+DAAA;EACA,WFtHI;EEuHJ,6CFzCY;AFochB;AIzZI;EACE,+BAAA;AJ2ZN;AIvZE;EAEE,mCAAA;EACA,yCAAA;EACA,aAAA;AJwZJ;AIrZE;EACE,mCAAA;AJuZJ;;AInZA,qBAAA;AC9IA;EACE,YJIc;EIHd,+EJEY;ADmiBd;AKniBE;EACE,cAAA;EACA,YAAA;ALqiBJ;AKliBE;EACE,yBAAA;EACA,sBAAA;ALoiBJ;AKjiBE;EACE,oBAAA;EACA,iBAAA;EACA,WHbI;EGcJ,eAAA;ALmiBJ;AKjiBI;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ALmiBN;AK/hBE;;EAEE,mBHnBO;EGoBP,sBAAA;ALiiBJ;;AK7hBA;EACE,gBJjCc;ADikBhB;;AK7hBA;EACE,eAAA;EACA,SAAA;EACA,mBHxBO;EGyBP,YAAA;EACA,aAAA;EACA,iBAAA;ALgiBF;;AK7hBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBHnDM;EGoDN,cHzCW;EG0CX,0BAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,gBAAA;ALgiBF;AK9hBE;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;ALgiBJ;;AMhmBA,sBAAA;AAGE;EACE,oDJ8Ee;EI7Ef,kBJqDe;EIpDf,aAAA;EACA,mCAAA;EACA,6BAAA;ANimBJ;AM9lBE;EACE,+DAAA;EACA,6CJmEY;EIlEZ,kBJ4Ce;AFojBnB;AM9lBI;EACE,6BAAA;ANgmBN;AM7lBI;;EAEE,WJpBE;AFmnBR;AM5lBI;EACE,oCAAA;AN8lBN;AM3lBI;;EAEE,WJ7BE;AF0nBR;AM1lBI;EACE,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AN4lBN;AM1lBM;EACE,aAAA;AN4lBR;AMvlBE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;ANylBJ;AMtlBE;EACE,2BAAA;ANwlBJ;AMrlBE;EACE,kBAAA;ANulBJ;AMplBE;EACE,UAAA;EACA,SAAA;ANslBJ;AMnlBE;EACE,SAAA;ANqlBJ;AMjlBI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;ANmlBN;AM/kBE;EACE,mBJ9EO;AF+pBX;AM9kBE;;EAEE,cJzEG;AFypBP;AM7kBE;EACE,eAAA;AN+kBJ;AM1kBE;EACE,mBJnFG;AF+pBP;;AMxkBA,qBAAA;AAIA;EACE,oCAAA;EACA,oDJ3BiB;EI4BjB,kBJpDiB;EIqDjB,iBAAA;EACA,kBAAA;EACA,mBJpDO;AF4nBT;AMtkBE;;EAEE,kBAAA;ANwkBJ;AMtkBI;;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;ANykBN;AMrkBE;EACE,oCAAA;EACA,0CAAA;EAEA,sBAAA;ANskBJ;AMpkBI;;EAEE,aAAA;ANskBN;AM9kBE;EAWE,qBAAA;ANskBJ;AMnkBE;EACE,oCAAA;ANqkBJ;AMlkBE;EACE,mCAAA;ANokBJ;AMlkBI;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;ANokBN;AMjkBI;EACE,mCAAA;EACA,yBAAA;ANmkBN;AMhkBI;EACE,mCAAA;ANkkBN;AM9jBE;EACE,oCAAA;EACA,2CAAA;ANgkBJ;AM9jBI;EACE,qCAAA;EACA,0CAAA;ANgkBN;AM7jBI;EACE,qCAAA;AN+jBN;AM3jBE;EACE,mCAAA;EACA,6BAAA;AN6jBJ;AM3jBI;EACE,mCAAA;EACA,yCAAA;AN6jBN;AM1jBI;EACE,mCAAA;AN4jBN;AMxjBE;EACE,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AN0jBJ;AMvjBE;EACE,kBAAA;ANyjBJ;AMtjBE;;EAEE,2BAAA;ANwjBJ;AMrjBE;EACE,gCAAA;ANujBJ;AMpjBE;;;EAGE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBJ3Ke;AFiuBnB;AMpjBI;;;;;;;;;EAIE,SAAA;EACA,UAAA;AN2jBN;;AMtjBA;EACE,oCAAA;EACA,oDJjKiB;EIkKjB,0CAAA;EACA,kBJ3LiB;EI4LjB,kBAAA;ANyjBF;AMvjBE;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,sBAAA;ANyjBJ;AMtjBM;EACE,WAAA;EACA,cAAA;EACA,0BAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;ANwjBR;AMpjBI;EAEE,oCAAA;ANqjBN;AMjjBM;EACE,aAAA;ANmjBR;AM/iBI;EACE,6BAAA;ANijBN;AM7iBE;EACE,SAAA;AN+iBJ;AM5iBE;EACE,UAAA;EACA,aAAA;AN8iBJ;;AM1iBA,sBAAA;AAGE;EACE,YAAA;AN2iBJ;AMxiBE;EACE,kBAAA;AN0iBJ;AMviBE;EACE,kBAAA;EACA,2BAAA;ANyiBJ;;AMriBA,qBAAA;AAEA;EACE,kBAAA;EACA,qBAAA;ANuiBF;AMriBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBJjUI;EIkUJ,YAAA;EACA,yBAAA;EACA,kBJ7QY;EI8QZ,+EJtPY;AF6xBhB;AMriBI;EACE,eAAA;ANuiBN;AMniBE;EACE,qCAAA;ANqiBJ;;AOt3BA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;APy3BJ;AOv3BI;EACI,kBAAA;EACA,kBLoDW;EKnDX,+ENLM;EMMN,iBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;APy3BR;AOt3BI;EACI,gBAAA;EACA,gBAAA;APw3BR;AOr3BI;EACI,eAAA;EACA,kBAAA;APu3BR;AOr3BQ;EACI,cLjBD;AFw4BX;AOp3BQ;EACI,mBL1BD;EK2BC,eAAA;APs3BZ;AOn3BQ;EACI,gCAAA;APq3BZ;;AOh3BA;EACI,qBAAA;APm3BJ;;AQ95BA,sBAAA;AAEA;EACE;IAAM,UAAA;IAAY,mBAAA;ERk6BlB;EQj6BA;IAAM,UAAA;ERo6BN;EQn6BA;IAAM,UAAA;IAAY,mBAAA;ERu6BlB;EQt6BA;IAAM,UAAA;IAAY,mBAAA;ER06BlB;AACF;AQx6BA;EACE;IAAM,UAAA;IAAY,mBAAA;ER46BlB;EQ36BA;IAAM,UAAA;ER86BN;EQ76BA;IAAM,UAAA;IAAY,mBAAA;ERi7BlB;EQh7BA;IAAM,UAAA;IAAY,mBAAA;ERo7BlB;AACF;AQl7BA,qBAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;ARm7BF;AQj7BE;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBNZG;EMaH,kCAAA;ARm7BJ;AQh7BE;EACE,mBNhBK;EMiBL,mBAAA;EACA,gCAAA;EACA,qBAAA;ARk7BJ;AQ/6BE;EACE,WAAA;EACA,YAAA;ARi7BJ;;AQ36BI;EACE,qBAAA;AR86BN;AQ36BI;EACE,qBAAA;AR66BN;AQx6BI;EACE,qBAAA;AR06BN;AQv6BI;EACE,qBAAA;ARy6BN;;AQl6BA;;EAEE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBNhBiB;EMiBjB,gBAAA;ARq6BF;AQn6BE;;EACE,oCAAA;ARs6BJ;;AQl6BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;ARq6BF;;AQj6BE;EACE,YAAA;ARo6BJ;AQl6BI;EACE,kBAAA;ARo6BN;;ASpgCA;EACE,WAAA;ATugCF;ASpgCE;;EAEE,WAAA;EACA,oBAAA;ATsgCJ;ASngCE;EACE,mBPSK;EORL,YAAA;EACA,uHPoES;EOnET,UAAA;EACA,sBAAA;ATqgCJ;ASjgCI;EACE,iBAAA;EACA,eAAA;EACA,kBPsCa;AF69BnB;AS//BE;;EAEE,6BAAA;EACA,mBAAA;ATigCJ;AS9/BE;EACE,mBAAA;EACA,gBAAA;EACA,wBAAA;ATggCJ;AS7/BE;EACE,uBAAA;AT+/BJ;AS5/BE;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AT8/BJ;AS3/BE;EACE,gBAAA;AT6/BJ;AS1/BE;EACE,gBAAA;AT4/BJ;AS1/BI;EACE,kBAAA;EACA,cP9CK;EO+CL,gBAAA;AT4/BN;;ASv/BA;EACE,mBP7CO;EO8CP,YAAA;EACA,6BAAA;AT0/BF;;AU5jCE;EACE,mBRGO;EQFP,cReG;EQdH,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AV+jCJ;AU7jCI;EACE,aAAA;AV+jCN;AU5jCI;EACE,kBAAA;AV8jCN;AUzjCI;EACE,iBAAA;EACA,eAAA;AV2jCN;;AWjlCA;EACE,WAAA;EACA,kBAAA;AXolCF;AWllCE;EACE,8BAAA;EACA,gBAAA;EACA,4BAAA;AXolCJ;AWjlCE;EACE,iBAAA;AXmlCJ;;AW/kCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AXklCF;;AW/kCA;EACE,yBTJK;ESKL,kBAAA;EACA,kBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AXilCF;;AW9kCA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AXilCF;;AW9kCA;EACE,0BAAA;AXilCF;;AW9kCA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AXilCF;;AW9kCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AXilCF;;AW9kCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AXilCF;;AW9kCA;EACE,WAAA;EACA,kBAAA;AXilCF;;AW7kCA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;AXglCF;;AW7kCA;EACE,aAAA;EACA,sBAAA;EACA,cTtES;AFspCX;;AW7kCA;EACE,eAAA;EACA,6BAAA;AXglCF;;AW7kCA;EACE,eAAA;EACA,gBAAA;AXglCF;;AW7kCA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AXglCF;;AW7kCA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AXglCF;;AW7kCA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AXglCF;;AW7kCA;EACE,aAAA;EACA,mBAAA;EAEA,gBAAA;AX+kCF;;AW5kCA;EACE,YAAA;AX+kCF;AW7kCE;EACE,YAAA;AX+kCJ;AW7kCE;EACE,YAAA;AX+kCJ;;AW3kCA;EACE,yBTjIS;AF+sCX;;AW1kCE;EACE,uBAAA;AX6kCJ;AW3kCE;EACE,uBAAA;AX6kCJ;;AWzkCA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AX4kCF;AW1kCE;EACE,cT3IG;AFutCP;;AWvkCE;EACE,cTvJO;ESwJP,eAAA;AX0kCJ;;AWtkCA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AXykCF;;AWtkCA;EACE,kBAAA;AXykCF;AWvkCE;EACE,eAAA;AXykCJ;AWtkCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,cTxKE;AFgvCN;;AWpkCA;EACE,eAAA;EACA,gBAAA;AXukCF;;AWpkCA;EACE,WAAA;EACA,kBAAA;AXukCF;;AWpkCA;EACE,mBAAA;AXukCF;;AWpkCA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AXukCF;;AWpkCA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EAEA,oCAAA;EACA,oDT3IiB;ES4IjB,0CAAA;EACA,kBTrKiB;AF2uCnB;AWpkCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AXskCJ;AWnkCE;EACE,YAAA;EACA,kBAAA;EACA,cThOO;AFqyCX;AWlkCE;EACE,gBAAA;EACA,YAAA;AXokCJ;AWlkCI;EACE,YAAA;AXokCN;AWlkCI;EACE,YAAA;AXokCN;;AW/jCA;EACE,WAAA;EACA,aAAA;EACA,oDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXkkCF;;AW/jCA;EACE,WAAA;AXkkCF;AWhkCE;EACE,yBAAA;EACA,yBAAA;AXkkCJ;AW/jCE;EACE,gBAAA;AXikCJ;;AW7jCA;EACE,kBAAA;AXgkCF;;AW7jCA;EACE;IACE,WAAA;EXgkCF;EW9jCA;IACE,WAAA;EXgkCF;EW7jCA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EX+jCF;EW5jCA;IACE,kBAAA;EX8jCF;EW7jCE;IACE,WAAA;EX+jCJ;AACF;AWxjCA;EACE;IACE,0BAAA;EX0jCF;EWvjCA;IACE,0BAAA;IACA,aAAA;EXyjCF;EWtjCA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EXwjCF;EWtjCE;IACE,uBAAA;EXwjCJ;EWrjCE;IACE,YAAA;EXujCJ;EWnjCA;IACE,iBAAA;EXqjCF;AACF;AY93CA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AZg4CF;;AY73CA;EACE,YAAA;EACA,mBVqDiB;EUpDjB,gBVLM;EUMN,uHVuEW;EUtEX,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AZg4CF;;AY73CA;EACE,eAAA;EACA,SAAA;AZg4CF;;AY73CA;EACE,WAAA;AZg4CF;;AY73CA;EACE,WAAA;EACA,2BAAA;AZg4CF;;AY73CA;EACE,aAAA;EACA,+BAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AZg4CF;;AY73CA;EACE,aAAA;EACA,kBAAA;AZg4CF;;AY73CA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AZg4CF;;AY73CA;EACE,aAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;AZg4CF;;AY73CA;EACE,aAAA;EACA,sCAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AZg4CF;;AY73CA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AZg4CF;;AY93CA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AZi4CF;;AY93CA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AZi4CF;;AY93CA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AZi4CF;;AY93CA;EACE,iCAAA;AZi4CF;;AY93CA;EACE,gCAAA;AZi4CF;;AY93CA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;AZi4CF;;AY93CA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AZi4CF;;AY93CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AZi4CF;;AY/3CA;EACE,eAAA;AZk4CF;;Aa//CA;EACE,8BAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,kBAAA;AbkgDF;;Aa//CA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AbkgDF;;Aa//CA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AbkgDF;AahgDE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AbkgDJ;;Aa9/CA;EACE;IACE,gBAAA;IACA,WAAA;EbigDF;Ea9/CA;IACE,YAAA;EbggDF;Ea9/CE;IACE,YAAA;EbggDJ;AACF;Aa5/CA;EACE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;Eb8/CF;Ea5/CA;IACE,kBAAA;IACA,eAAA;IACA,OAAA;Eb8/CF;Ea5/CA;IACE,kBAAA;IACA,QAAA;Eb8/CF;Ea7/CE;IACE,YAAA;Eb+/CJ;AACF;AchkDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AdkkDF;;Ac/jDA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AdkkDF;;Ac/jDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AdkkDF;;Ac/jDA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;AdkkDF;;Ac/jDA;EACE,4BAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AdkkDF;;Ac/jDA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AdkkDF;;Ac/jDA;EACE,uBAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;AdkkDF;;Ac/jDA;EACE,0BAAA;EACA,aAAA;AdkkDF;;Ac/jDA;EACE,iBAAA;EACA,eAAA;EACA,eAAA;AdkkDF;;Ac/jDA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AdkkDF;;Ac/jDA;EACE,iBAAA;AdkkDF;;Ac/jDA;EACE,6CAAA;EACA,wBAAA;EACA,0BAAA;AdkkDF;;Ac/jDA;EACE,aAAA;AdkkDF;;Ac/jDA;EACE,wCAAA;EACA,aAAA;AdkkDF;;Ac/jDA;EACE,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AdkkDF;;Ac/jDA;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AdkkDF;;Ac/jDA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AdkkDF;;Ac/jDA;EACE,cAAA;AdkkDF;;Ac/jDA;EACE,eAAA;EACA,eAAA;EACA,8BAAA;AdkkDF;;Ac/jDA;EACE,0DAAA;EACA,iBAAA;EACA,8BAAA;AdkkDF;;Ac/jDA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AdkkDF;;Ac/jDA;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AdkkDF;;Ac/jDA;EACE,2CAAA;AdkkDF;;Ac/jDA;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AdkkDF;;Ac/jDA;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;AdkkDF;;Ac/jDA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AdkkDF;;Ac/jDA;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AdkkDF;;Ac/jDA;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AdkkDF;;Ac/jDA;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;AdkkDF;;Ac/jDA;EACE,2CAAA;AdkkDF;;Ac/jDA;EACE,eAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;AdkkDF;;Ac/jDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AdkkDF;;Ac/jDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AdkkDF;;Ac/jDA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AdkkDF;;Ac/jDA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;AdkkDF;;Ac/jDA;EACE,cAAA;AdkkDF;;Ac/jDA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AdkkDF;;Ac/jDA;EACE,wBAAA;AdkkDF;;Ac/jDA;EACE,iBAAA;AdkkDF;;Ac/jDA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AdkkDF;;Ac/jDA;EACE,qBAAA;EACA,cAAA;AdkkDF;;Aev1DA;EACI,2BAAA;Af01DJ;;Aev1DA;EACI,WAAA;EACA,yBAAA;Af01DJ;;AgBt1DE;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AhBy1DJ;AgBr1DE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AhBu1DJ;;AgBrsDA;EACE,iCAAA;EACA,oDdtFiB;EcuFjB,uCAAA;EACA,SAAA;EACA,qBAAA;AhBwsDF;AgBtsDE;EACE,Wd5KI;AFo3DR;AgBrsDE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AhBusDJ;AgBrsDI;EACE,mCAAA;AhBusDN;AgBlsDI;EACE,gBAAA;EACA,SAAA;EACA,Wd9LE;Ec+LF,SAAA;EACA,qBAAA;AhBosDN;AgBlsDM;EAIE,gBAAA;EACA,SAAA;EACA,UAAA;AhBisDR;AgB7rDI;EACE,+BAAA;AhB+rDN;AgBtrDE;EACE,iCAAA;EACA,kCAAA;EACA,iCAAA;AhBwrDJ;AgBprDI;EACE,aAAA;AhBsrDN;AgBnrDI;EACE,kCAAA;AhBqrDN;;AgBhrDA;EACE,iBAAA;EACA,cdrOS;EcsOT,kBdlLiB;EcmLjB,sBAAA;EACA,+DAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;AhBmrDF;;AgBhrDA;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;AhBmrDF;;AgBhrDA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;AhBmrDF;AgBjrDE;EACE,YAAA;AhBmrDJ;;AgB9qDE;EACE,WdpQI;AFq7DR;;AAl6DA;EACE,qBAAA;AAq6DF","sourcesContent":["/* overpass-regular - latin */\n@font-face {\n  font-family: Overpass;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../../public/fonts/Overpass/overpass-v10-latin-regular.eot\"); /* IE9 Compat Modes */\n  src:\n\n    local(\"\"),\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-regular.eot?#iefix\") format(\"embedded-opentype\"), /* IE6-IE8 */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-regular.woff2\") format(\"woff2\"), /* Super Modern Browsers */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-regular.woff\") format(\"woff\"), /* Modern Browsers */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-regular.ttf\") format(\"truetype\"), /* Safari, Android, iOS */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-regular.svg#Overpass\") format(\"svg\"); /* Legacy iOS */\n}\n\n/* overpass-600 - latin */\n@font-face {\n  font-family: Overpass;\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"../../public/fonts/Overpass/overpass-v10-latin-600.eot\"); /* IE9 Compat Modes */\n  src:\n\n    local(\"\"),\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-600.eot?#iefix\") format(\"embedded-opentype\"), /* IE6-IE8 */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-600.woff2\") format(\"woff2\"), /* Super Modern Browsers */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-600.woff\") format(\"woff\"), /* Modern Browsers */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-600.ttf\") format(\"truetype\"), /* Safari, Android, iOS */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-600.svg#Overpass\") format(\"svg\"); /* Legacy iOS */\n}\n\n/* overpass-700 - latin */\n@font-face {\n  font-family: Overpass;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"../../public/fonts/Overpass/overpass-v10-latin-700.eot\"); /* IE9 Compat Modes */\n  src:\n\n    local(\"\"),\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-700.eot?#iefix\") format(\"embedded-opentype\"), /* IE6-IE8 */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-700.woff2\") format(\"woff2\"), /* Super Modern Browsers */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-700.woff\") format(\"woff\"), /* Modern Browsers */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-700.ttf\") format(\"truetype\"), /* Safari, Android, iOS */\n    url(\"../../public/fonts/Overpass/overpass-v10-latin-700.svg#Overpass\") format(\"svg\"); /* Legacy iOS */\n}\n\n/* asap-italic - latin */\n@font-face {\n  font-family: Asap;\n  font-style: italic;\n  font-weight: 400;\n  src: url(\"../../public/fonts/Asap/asap-v21-latin-italic.eot\"); /* IE9 Compat Modes */\n  src:\n\n    local(\"\"),\n    url(\"../../public/fonts/Asap/asap-v21-latin-italic.eot?#iefix\") format(\"embedded-opentype\"), /* IE6-IE8 */\n    url(\"../../public/fonts/Asap/asap-v21-latin-italic.woff2\") format(\"woff2\"), /* Super Modern Browsers */\n    url(\"../../public/fonts/Asap/asap-v21-latin-italic.woff\") format(\"woff\"), /* Modern Browsers */\n    url(\"../../public/fonts/Asap/asap-v21-latin-italic.ttf\") format(\"truetype\"), /* Safari, Android, iOS */\n    url(\"../../public/fonts/Asap/asap-v21-latin-italic.svg#Asap\") format(\"svg\"); /* Legacy iOS */\n}\n","// Include ICON font\n// (to update the icons, upload config.json to fontello.com, edit icons and export again)\n@import '../fontello/css/ehaclinics.css';\n\n// Tweak Boostrap variables before importing bootstrap\n@import 'bootstrap-variables';\n@import 'fonts';\n@import 'globals';\n@import 'button';\n@import 'datepicker';\n@import '../components/layout/layout';\n@import '../components/form/form';\n@import '../components/branches/branches';\n@import '../components/loading/loading';\n@import '../components/table/table';\n@import '../components/action-menu/actionMenu';\n@import '../components/update-booking/_cancel';\n@import '../components/service-providers/_serviceProviderSchedule';\n@import '../components/update-booking/bookingFallback';\n@import '../components/service-providers/providerCalendar';\n@import '../components/booking-list/bookings';\n@import '../components/clients/_clients';\n\n.redBorder {\n  border: 1px solid red;\n}\n","///////\n///////\n/////// EHA VARIABLES\n\n$drop-shadow: 0 1px 4px rgba($body-color, 0.2), 0 1px 1px rgba($purple, 0.2);\n$topnav-height: $spacer * 4;\n\n///////\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: Overpass, sans-serif;\n  font-size: 15px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  @media screen and (max-width: 1200px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 768px) {\n    font-size: 13px;\n  }\n}\n\n* {\n  box-sizing: border-box;\n}\n\nb {\n  font-weight: 600;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.link:hover {\n  color: $primary;\n  cursor: pointer;\n}\n\nbutton {\n  border: 0;\n  background: 0;\n  color: inherit;\n\n  &:disabled {\n    opacity: 0.5;\n  }\n}\n\n.headline {\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.figure-xl {\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.badge {\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding-bottom: 0.2rem;\n  padding-top: 0.3rem;\n\n  &.bg-light {\n    color: $body-color;\n    font-weight: 400;\n  }\n}\n\n.circle {\n  box-shadow: $box-shadow-inset;\n  background: $gray-100;\n  border: 1px solid rgba($light, 0.5);\n  width: 6rem;\n  height: 6rem;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: column;\n  flex-shrink: 0;\n  justify-content: center;\n  font-weight: 600;\n\n  &.circle-xs {\n    width: 1.6rem;\n    height: 1.6rem;\n  }\n}\n\n.label {\n  font-family: Asap, sans-serif;\n  font-style: italic;\n  font-weight: 400;\n  font-size: 0.94rem;\n}\n\n.label-group {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 0.5rem;\n  align-items: end;\n\n  .label {\n    justify-self: end;\n    margin-bottom: 0.1em;\n  }\n}\n\n.box {\n  border-radius: $border-radius-lg;\n  background: white;\n}\n\n.text-box {\n  border-radius: $border-radius-sm;\n  background: $gray-200;\n  padding: 0.5em 0.5em 0.3em;\n  margin-bottom: 0.5rem;\n  display: inline-block;\n}\n\n.text-box-alert {\n  background: rgba($danger, 0.3);\n}\n\n.icon-list {\n  list-style: none;\n  padding-left: 0;\n\n  li {\n    display: flex;\n    align-items: flex-start;\n  }\n}\n\n.main-bg-container {\n  min-height: calc(100vh - $topnav-height);\n  background: $gray-200;\n  width: 100%;\n\n  &.fullscreen {\n    min-height: 100vh;\n  }\n}\n\n.modal-min-90 {\n  @media screen and (min-width: 576px) and (max-width: 992px) {\n    max-width: 800px;\n    width: 90vw;\n  }\n}\n\n.modal-backdrop.front {\n  z-index: 1055;\n}\n\n.filter-toggle {\n  input[type='checkbox'] {\n    position: absolute;\n    left: -9999px;\n  }\n\n  input[type='checkbox'] + label {\n    cursor: pointer;\n    margin: 0;\n    padding-right: 34px;\n    position: relative;\n    color: $gray-800;\n    width: 100%;\n\n    &::before {\n      content: '';\n      display: block;\n      position: absolute;\n      right: 0;\n      top: 1px;\n      width: 26px;\n      height: 16px;\n      background-color: rgba($body-color, 0.2);\n      box-shadow: 0 0 2px rgba($body-color, 0.2) inset;\n      border-radius: 12px;\n    }\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 2px;\n      right: 1px;\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      background: $white;\n      transition: all 0.2s;\n    }\n  }\n\n  input[type='checkbox']:checked + label {\n    color: $body-color;\n\n    &::before {\n      background: $primary;\n    }\n\n    &::after {\n      background: $white;\n      right: 11px;\n    }\n  }\n}\n\n.card {\n  border: none;\n  border-radius: $border-radius-lg;\n  background: $white;\n  box-shadow: $box-shadow;\n  position: relative;\n\n  .label {\n    color: $gray-800;\n  }\n}\n\n.side-nav {\n  width: 20%;\n  min-width: 14rem;\n  max-width: 16rem;\n  border-right: 1px solid $light;\n}\n\n.content {\n  flex: 1;\n}\n\n.list-item {\n  font-weight: 600;\n  padding: $spacer * 0.8 $spacer;\n  background: rgba($white, 0.4);\n  border-radius: $border-radius-lg;\n  margin: $spacer * 0.5 0;\n  position: relative;\n  transition: box-shadow 0.4s;\n  display: flex;\n  align-items: center;\n\n  &::before {\n    content: '';\n    width: 1rem;\n    height: 1rem;\n    background: $white;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: -0.4rem;\n    top: calc(50% - 0.5rem);\n    opacity: 0;\n    transition: box-shadow 0.4s;\n  }\n\n  .side-nav-icon {\n    margin-left: -2rem;\n    position: absolute;\n  }\n\n  &.active,\n  &:hover {\n    background: $white;\n    box-shadow: $box-shadow;\n    color: $primary;\n\n    &::before {\n      box-shadow: 2px 2px 2px rgba($gray-900, 0.1);\n      opacity: 1;\n    }\n  }\n}\n.pointer {\n  cursor: pointer;\n}\n.table-list {\n  background: $white url('../../public/img/bg.jpg');\n  background-size: cover;\n  min-height: calc(100vh - $topnav-height);\n  padding-bottom: 4rem;\n\n  .table-list-header {\n    background: $purple;\n    align-items: center;\n  }\n\n  .table-list-search {\n    border-right: 1px solid $purple;\n    color: $white;\n\n    input {\n      background: none;\n      border: 0;\n      color: $white;\n      width: 100%;\n      min-width: 10rem;\n\n      &:focus,\n      &:focus-visible,\n      &:active,\n      &:hover {\n        background: none;\n        border: 0;\n        outline: 0;\n      }\n    }\n\n    input::placeholder {\n      color: rgba($white, 0.5);\n    }\n  }\n\n  .table-list-filters {\n    background: rgba($body-color, 0.1);\n    box-shadow: $box-shadow-inset;\n    border: 1px solid rgba($body-color, 0.1);\n    flex: 1;\n    border-radius: 2rem;\n  }\n\n  .eha-table {\n    td {\n      border-bottom: 2px solid transparent;\n\n      &:first-child {\n        border-left: 0.5rem solid transparent;\n      }\n\n      &:last-child {\n        border-right: 0.5rem solid transparent;\n      }\n    }\n\n    th {\n      &:first-child {\n        border-left: 0.5rem solid $purple;\n      }\n\n      &:last-child {\n        border-right: 0.5rem solid $purple;\n      }\n    }\n  }\n}\n","///////\n///////\n/////// Bootstrap Variables\n\n$white: #fff !default;\n$gray-100: #fcfdfd;\n$gray-200: #f4f8f6;\n$gray-300: #e7f0f2;\n$gray-400: #dbe9ef;\n$gray-500: #c3d2d8;\n$gray-600: #acbcbf;\n$gray-700: #8d9da0;\n$gray-800: #6e7f80;\n$gray-900: #405352;\n$black: #000 !default;\n$body-color: #314342;\n\n// scss-docs-start color-variables\n$blue: #41b5fd;\n$indigo: #5b74c6;\n$purple: #7f8baa;\n$pink: #d63384 !default;\n$red: #f47d82;\n$orange: #fd7e14 !default;\n$yellow: #f2dc35;\n$green: #65e5aa;\n$teal: #20c997 !default;\n$cyan: #0dcaf0 !default;\n\n// scss-docs-start theme-color-variables\n$primary: $blue !default;\n$secondary: $indigo;\n$secondary-light: #8b9dd6;\n$success: $green !default;\n$info: $purple;\n$warning: $yellow !default;\n$danger: $red !default;\n$light: $gray-400;\n$dark: $gray-900 !default;\n$blue-light: #f5ffff;\n$body-light: $gray-700;\n\n// theme colors\n$theme-colors: (\n  \"primary\": $primary,\n  \"secondary\": $secondary,\n  \"secondary-light\": $secondary-light,\n  \"success\": $success,\n  \"info\": $info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark,\n  \"blue-light\": $blue-light,\n  \"body-light\": $body-light,\n  \"white\": $white\n);\n\n// scss-docs-start border-radius-variables\n$border-radius: 6px;\n$border-radius-sm: 4px;\n$border-radius-lg: 12px;\n$border-radius-pill: 50rem !default;\n$spacer: 1rem;\n$paragraph-margin-bottom: 0.8rem;\n$font-weight-bold: 600;\n$enable-negative-margins: true;\n\n// Navbar\n\n// $navbar-padding-x:            $spacer;\n// $navbar-padding-y:            $spacer;\n$navbar-dark-color: $gray-600;\n$navbar-dark-hover-color: $primary;\n$navbar-brand-padding-y: 0;\n$navbar-brand-font-size: 1rem;\n$nav-link-font-size: 14px;\n$link-decoration: none;\n\n// Shadows\n\n$box-shadow: 0 0 6px rgba($gray-900, 0.1), 1px 1px 1px rgba($purple, 0.2), 0 0 2px rgba($white, 0.3) inset;\n$box-shadow-sm: 1px 1px 1px rgba($gray-900, 0.2);\n$box-shadow-lg: 0 0 6px rgba($gray-900, 0.2), 1px 1px 2px rgba($purple, 0.2);\n$box-shadow-inset: 1px 1px 6px rgba($gray-900, 0.06) inset;\n\n// Dropdown\n\n$caret-spacing: 0.5em;\n$dropdown-border-color: rgba($gray-500, 0.15);\n\n// Button\n\n$input-btn-padding-y: $spacer * 0.5;\n$input-btn-padding-x: $spacer * 1.5;\n$input-btn-padding-y-sm: 0.2rem;\n$input-btn-padding-x-sm: 1rem;\n$input-btn-padding-y-lg: 0.5rem !default;\n$input-btn-padding-x-lg: 1rem !default;\n$input-btn-focus-box-shadow: $box-shadow;\n\n// Modal\n\n$modal-inner-padding: $spacer * 1.5;\n$modal-header-padding-y: $spacer;\n$modal-header-padding-x: $spacer * 1.5;\n\n// scss-docs-start accordion-variables\n$accordion-padding-y: 0.75rem;\n$accordion-padding-x: 1rem;\n$accordion-border-width: 0;\n\n// Font\n\n$font-size-base: 1rem;\n$h1-font-size: $font-size-base * 2.5 !default;\n$h2-font-size: $font-size-base * 1.9;\n$h3-font-size: $font-size-base * 1.75 !default;\n$h4-font-size: $font-size-base * 1.5 !default;\n$h5-font-size: $font-size-base * 1.25 !default;\n$h6-font-size: $font-size-base !default;\n",".btn-primary {\n  color: $white;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  box-shadow: $box-shadow;\n  padding-bottom: $spacer * 0.4;\n\n  &:focus,\n  &:hover,\n  &:active {\n    color: $white;\n  }\n\n  &.pill {\n    border-radius: 50rem;\n  }\n\n  &.btn-sm {\n    padding-bottom: 0.16em;\n  }\n\n  &:disabled {\n    color: $white;\n    background: $gray-600;\n    border-color: $gray-600;\n  }\n\n  &.loading {\n    color: $gray-500;\n    background: $gray-100;\n    border-color: $light;\n    box-shadow: none;\n\n    .loading-dots {\n      position: relative;\n      margin-right: 0.6rem;\n      margin-left: -0.3rem;\n      top: 0.15rem;\n    }\n  }\n}\n\n.btn-danger {\n  color: $white;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  box-shadow: $box-shadow;\n  padding-bottom: $spacer * 0.4;\n\n  &:focus,\n  &:hover,\n  &:active {\n    color: $white;\n  }\n\n  &.pill {\n    border-radius: 50rem;\n  }\n\n  &.btn-sm {\n    padding-bottom: 0.16em;\n  }\n\n  &:disabled {\n    color: $white;\n    background: $gray-600;\n    border-color: $gray-600;\n  }\n\n  &.loading {\n    color: $gray-500;\n    background: $gray-100;\n    border-color: $light;\n    box-shadow: none;\n\n    .loading-dots {\n      position: relative;\n      margin-right: 0.6rem;\n      margin-left: -0.3rem;\n      top: 0.15rem;\n    }\n  }\n}\n\n.btn-link {\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  display: flex;\n  align-items: center;\n}\n","/* stylelint-disable */\n\n.react-datepicker-popper .react-datepicker {\n\tbackground: $white;\n\tbox-shadow: $drop-shadow;\n\tborder: 1px solid $light;\n\tfont-family: Overpass, sans-serif;\n\tfont-size: 0.94rem;\n\tposition: relative;\n  display: flex;\n\n  .react-datepicker__navigation {\n    top: 1rem;\n  }\n\n\t.react-datepicker__header {\n  \tbackground-color: $gray-100;\n    border-bottom: 1px solid transparent;\n    height:5rem;\n    padding: 0.8rem 0.5rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-year-header {\n    font-size: 1.4rem;\n    font-weight: 300;\n  }\n\n  .react-datepicker-time__header {\n    margin-top: auto;\n  }\n\n  .react-datepicker__day-name {\n    font-size: 0.7rem;\n    text-transform: uppercase;\n    color: $secondary-light;\n    width: 2rem;\n  }\n\n  .react-datepicker__day {\n    border-radius: 100%;\n    width: 2rem;\n    height: 2rem;\n    line-height: 2rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .react-datepicker__time-container {\n    border-left: 1px solid $light;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n    background: $primary;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    background: $primary;\n  }\n\n  .react-datepicker__day--keyboard-selected, \n  .react-datepicker__month-text--keyboard-selected, \n  .react-datepicker__quarter-text--keyboard-selected, \n  .react-datepicker__year-text--keyboard-selected {\n    background: $secondary;\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow,\n  .react-datepicker__navigation-icon::before {\n    border-color: $primary;\n    border-width: 2px 2px 0 0;\n  }\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker .react-datepicker__triangle::before {\n  border-bottom-color: $gray-400;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker .react-datepicker__triangle::after {\n  border-bottom-color: $gray-100;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker .react-datepicker__triangle::before {\n  border-top-color: $gray-500;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker .react-datepicker__triangle::after {\n  border-bottom-color: $white;\n}\n\n.react-datepicker-wrapper .react-datepicker__close-icon::after {\n  background: none;\n  font-size: 1.4rem;\n}\n\n.react-datepicker__input-container input {\n\twidth: 100%;\n\tpadding: 0.6rem 1rem 0.4rem;\n\tbox-shadow: $box-shadow-inset;\n  border-radius: $border-radius-sm;\n  background: rgba($primary, 0.2);\n  border: 1px solid transparent;\n  margin-bottom: 1px;\n\n  &.date-filter {\n    background: lighten($purple, 3);\n    color: $white;\n    box-shadow: $box-shadow-sm;\n\n    &::placeholder {\n      color: rgba($white, 0.6);\n    }\n  }\n\n  &:focus-within,\n  &:focus-visible {\n    background: rgba($primary, 0.3);\n    border: 1px solid rgba($primary, 0.3);\n    outline: none;\n  }\n\n  &:hover {\n    background: rgba($primary, 0.3);\n  }\n}\n\n/* stylelint-enable */\n",".eha-topnav {\n  height: $topnav-height;\n  box-shadow: $drop-shadow;\n\n  .navbar-brand {\n    line-height: 0;\n    height: $spacer * 3;\n  }\n\n  .nav-link {\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n  }\n\n  .user-name .nav-link {\n    text-transform: none;\n    letter-spacing: 0;\n    color: $white;\n    font-size: 1rem;\n\n    &::before {\n      font-family: ehaclinics, sans-serif;\n      display: inline-block;\n      width: 1em;\n      margin-right: 0.5em;\n      text-align: center;\n      content: \"\\e805\";\n    }\n  }\n\n  .navbar-collapse.collapse,\n  .navbar-collapse.collapsing {\n    background: $gray-900;\n    padding: $spacer * 0.5 $spacer 0;\n  }\n}\n\n.eha-topnav ~ .main {\n  margin-top: $topnav-height;\n}\n\n.bookmarks {\n  position: fixed;\n  bottom: 0;\n  background: $purple;\n  width: 100vw;\n  display: flex;\n  padding: 0 0.5rem;\n}\n\n.bookmark {\n  display: flex;\n  align-items: center;\n  font-size: 0.9rem;\n  flex: 1 1 auto;\n  background: $white;\n  color: $body-color;\n  border-radius: $border-radius $border-radius 0 0;\n  padding: 0.2rem 0;\n  margin: 0.75rem 0.2rem 0;\n  width: 10%;\n  max-width: 16rem;\n\n  .bookmark-title {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n}","// React select\n\n/* stylelint-disable */\n\n.select {\n  &.select-dark {\n    box-shadow: $box-shadow-inset;\n    border-radius: $border-radius-sm;\n    padding: 0rem;\n    background: rgba($primary, 0.2);\n    border: 1px solid transparent;\n  }\n\n  &.select-filter {\n    background: lighten($purple, 3);\n    box-shadow: $box-shadow-sm;\n    border-radius: $border-radius-sm;\n\n    .select__value-container {\n      padding: 0.5rem 0 0.4rem 1rem;\n    }\n\n    .select__single-value,\n    .select__input-container {\n      color: $white;\n    }\n\n    .select__indicator-separator {\n      background: rgba($white, 0.2);\n    }\n\n    .select__indicator,\n    .select__indicator:hover {\n      color: $white;\n    }\n\n    .select__placeholder {\n      color: rgba($white, 0.6);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  .select__control {\n    border: 0;\n    background: 0;\n    box-shadow: none;\n    height: auto;\n  }\n\n  .select__value-container {\n    padding: 1rem 1.2rem 0.8rem;\n  }\n\n  .select__value-container--has-value.select__value-container--is-multi {\n    padding-left: 1rem;\n  }\n\n  .select__input-container {\n    padding: 0;\n    margin: 0;\n  }\n\n  .select__input {\n    margin: 0;\n  }\n\n  .select__placeholder {\n    &::before {\n      content: '';\n      display: block;\n      width: 1rem;\n      height: 1px;\n      border-bottom: 1px solid $primary;\n      position: absolute;\n      left: 1.2rem;\n      bottom: 1rem;\n    }\n  }\n\n  .select__multi-value {\n    background: $light;\n  }\n\n  .select__indicator,\n  .select__indicator:hover {\n    color: $primary;\n  }\n\n  .select__menu {\n    margin-top: 1px;\n    //margin-left: -0.6rem;\n    //width: calc(100% + 1.2rem);\n  }\n\n  .select__option--is-selected {\n    background: $primary;\n  }\n}\n\n/* stylelint-enable */\n\n// Single form field\n\n.form-group {\n  background: rgba($light, 0.2);\n  box-shadow: $box-shadow-inset;\n  border-radius: $border-radius-sm;\n  padding: 0 0.6rem;\n  position: relative;\n  margin-bottom: $spacer;\n\n  .input-wrapper,\n  .select-wrapper {\n    position: relative;\n\n    &.empty::before {\n      content: '';\n      display: block;\n      width: 1rem;\n      height: 1px;\n      border-bottom: 1px solid $primary;\n      position: absolute;\n      left: 1.2rem;\n      bottom: 1rem;\n    }\n  }\n\n  &:focus-within {\n    background: rgba($light, 0.4);\n    border: 1px solid rgba($light, 0.6);\n\n    /* stylelint-disable */\n\n    .input-wrapper::before,\n    .select__placeholder {\n      display: none;\n    }\n\n    /* stylelint-enable */\n  }\n\n  &:hover {\n    background: rgba($light, 0.4);\n  }\n\n  &.required {\n    background: rgba($primary, 0.1);\n\n    label::after {\n      content: '*';\n      font-size: 1.6rem;\n      position: absolute;\n      margin-left: 0.2rem;\n      top: -0.1rem;\n    }\n\n    &:focus-within {\n      background: rgba($primary, 0.2);\n      border: 1px solid $light;\n    }\n\n    &:hover {\n      background: rgba($primary, 0.2);\n    }\n  }\n\n  &.error {\n    background: rgba($danger, 0.1);\n    border: 1px solid rgba($danger, 0.15);\n\n    &:focus-within {\n      background: rgba($danger, 0.15);\n      border: 1px solid rgba($danger, 0.2);\n    }\n\n    &:hover {\n      background: rgba($danger, 0.15);\n    }\n  }\n\n  &.form-group-dark {\n    background: rgba($primary, 0.2);\n    border: 1px solid transparent;\n\n    &:focus-within {\n      background: rgba($primary, 0.3);\n      border: 1px solid rgba($primary, 0.3);\n    }\n\n    &:hover {\n      background: rgba($primary, 0.3);\n    }\n  }\n\n  label {\n    display: block;\n    font-family: Asap, sans-serif;\n    font-style: italic;\n    font-weight: 400;\n    font-size: 0.94rem;\n    padding: 5px;\n    color: black;\n    margin: 0.4rem 0 0;\n  }\n\n  .form-text {\n    margin: 0.2rem 0 0;\n  }\n\n  input,\n  textarea {\n    padding: 1rem 1.2rem 0.8rem;\n  }\n\n  select {\n    padding: 1rem 1.2rem 0.8rem 1rem;\n  }\n\n  input,\n  select,\n  textarea {\n    border: 0;\n    background: none;\n    color: black;\n    width: 100%;\n    border-radius: $border-radius-sm;\n\n    &:active,\n    &:focus,\n    &:focus-within,\n    &:focus-visible {\n      border: 0;\n      outline: 0;\n    }\n  }\n}\n\n.form-group-multi {\n  background: rgba($light, 0.2);\n  box-shadow: $box-shadow-inset;\n  border: 1px solid rgba($light, 0.3);\n  border-radius: $border-radius-sm;\n  position: relative;\n\n  .form-group {\n    background: none;\n    box-shadow: none;\n    border: 1px solid transparent;\n    margin: 0;\n    padding: 0.1rem 0.6rem;\n\n    .input-wrapper {\n      &.empty::after {\n        content: '';\n        display: block;\n        width: calc(100% - 3.7rem);\n        height: 1px;\n        border-bottom: 1px solid $light;\n        position: absolute;\n        left: 2.5rem;\n        bottom: 1rem;\n      }\n    }\n\n    &:hover,\n    &:focus-within {\n      background: rgba($light, 0.2);\n    }\n\n    &:focus-within {\n      .input-wrapper.empty::after {\n        display: none;\n      }\n    }\n\n    &.required {\n      border: 1px solid transparent;\n    }\n  }\n\n  .row {\n    margin: 0;\n  }\n\n  .row > div {\n    padding: 0;\n    display: flex;\n  }\n}\n\n/* stylelint-disable */\n\n.form-group {\n  .PhoneInputCountry {\n    left: 1.2rem;\n  }\n\n  .PhoneInputCountryIconImg {\n    border-radius: 2px;\n  }\n\n  .PhoneInputCountryIcon {\n    border-radius: 2px;\n    box-shadow: 0 0 2px $gray-600;\n  }\n}\n\n/* stylelint-enable */\n\n.delete-button {\n  position: relative;\n  display: inline-block;\n\n  .confirmation-dialog {\n    z-index: 100;\n    text-align: left;\n    position: absolute;\n    bottom: -1rem;\n    right: 0px;\n    background: $white;\n    width: 19rem;\n    padding: 0.8rem 1rem 1rem;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow-lg;\n\n    input {\n      padding: 0.5rem;\n    }\n  }\n\n  .small {\n    text-transform: capitalize !important;\n  }\n}\n",".branch-search {\n    position: relative;\n    padding: 0;\n    min-width: 16rem;\n    flex: 1;\n\n    .branch-dropdown {\n        position: absolute;\n        border-radius: $border-radius-sm;\n        box-shadow: $drop-shadow;\n        background: white;\n        width: 100%;\n        left: 0;\n        display: flex;\n        flex-direction: column;\n        z-index: 100;\n    }\n\n    .dropdown-items {\n        overflow-y: auto;\n        max-height: 60vh;\n    }\n\n    .branch-dropdown-item {\n        padding: 0.5rem;\n        font-size: 0.94rem;\n\n        .label {\n            color: $gray-700;\n        }\n\n        &:hover {\n            background: $gray-200;\n            cursor: pointer;\n        }\n\n        &:not(:last-child) {\n            border-bottom: 1px solid $light;\n        }\n    }\n}\n\n.selected-branches-details{\n    border: 1px solid red;\n}\n","/* stylelint-disable */\n\n@keyframes scaledown {\n  0%   {opacity: 0; transform: scale(1)}\n  30%  {opacity: 1}\n  80%  {opacity: 1; transform: scale(0)}\n  100% {opacity: 0; transform: scale(0)}\n}\n\n@keyframes scaleup {\n  0%   {opacity: 1; transform: scale(0)}\n  10%  {opacity: 1}\n  70%  {opacity: 0; transform: scale(1)}\n  100% {opacity: 0; transform: scale(1)}\n}\n\n/* stylelint-enable */\n\n.loading-spinner {\n  width: 3rem;\n  height: 3rem;\n  position: relative;\n  display: inline-block;\n\n  .circle1,\n  .circle2 {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 100%;\n    background: $primary;\n    animation: scaledown 2.8s infinite;\n  }\n\n  .circle2 {\n    background: $indigo;\n    transform: scale(0);\n    animation: scaleup 2.8s infinite;\n    animation-delay: 0.8s;\n  }\n\n  &.sm {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n.loading-dots {\n  .loading-spinner:nth-of-type(2) {\n    .circle1 {\n      animation-delay: 0.4s;\n    }\n\n    .circle2 {\n      animation-delay: 1.2s;\n    }\n  }\n\n  .loading-spinner:nth-of-type(3) {\n    .circle1 {\n      animation-delay: 0.8s;\n    }\n\n    .circle2 {\n      animation-delay: 1.6s;\n    }\n  }\n}\n\n////////// loading placeholders\n\n.bar-placeholder,\n.circle-placeholder {\n  background: rgba($light, 0.5);\n  width: 100%;\n  height: 1rem;\n  border-radius: $border-radius-sm;\n  margin: 0.5rem 0;\n\n  &.white {\n    background: rgba($white, 0.4);\n  }\n}\n\n.circle-placeholder {\n  width: 6rem;\n  height: 6rem;\n  border-radius: 100%;\n  margin: 0.5rem;\n}\n\n.loading-placeholder {\n  .bar-placeholder {\n    height: 3rem;\n\n    &:first-child {\n      margin-right: 1rem;\n    }\n  }\n}\n",".eha-table {\n  width: 100%;\n\n\n  thead,\n  tbody {\n    width: 100%;\n    padding: 1rem 1.5rem;\n  }\n\n  thead {\n    background: $purple;\n    color: white;\n    box-shadow: $box-shadow;\n    z-index: 1;\n    padding: 0.5rem 1.5rem;\n  }\n\n  tbody {\n    tr {\n      background: white;\n      margin-top: 2px;\n      border-radius: $border-radius-sm;\n    }\n  }\n\n  th,\n  td {\n    padding: 0.7rem 0.8rem 0.5rem;\n    white-space: nowrap;\n  }\n\n  td {\n    white-space: nowrap;\n    overflow: hidden;\n    vertical-align: baseline;\n  }\n\n  td:not(:last-child) {\n    text-overflow: ellipsis;\n  }\n\n  th {\n    font-family: Asap, sans-serif;\n    font-style: italic;\n    font-weight: 400;\n    font-size: 14px;\n  }\n\n  td.name {\n    font-weight: 600;\n  }\n\n  td.age {\n    font-weight: 600;\n\n    span {\n      margin-left: 0.2em;\n      color: $gray-800;\n      font-weight: 400;\n    }\n  }\n}\n\n.pagination-bar {\n  background: $purple;\n  color: white;\n  padding: 0.7rem 1.5rem 0.5rem;\n}\n",".dropdown.action-menu {\n  .dropdown-toggle {\n    background: $gray-100;\n    color: $primary;\n    border: 0;\n    border-radius: 2rem;\n    font-size: 1.5rem;\n    padding: 0.2rem 0.5rem;\n    line-height: 0;\n\n    &::after {\n      display: none;\n    }\n\n    .dropdown-menu {\n      margin-top: 0.2rem;\n    }\n  }\n\n  &.small {\n    .dropdown-toggle {\n      font-size: 1.1rem;\n      padding: 0.2rem;\n    }\n  }\n}\n",".ca-main {\n  width: 100%;\n  position: relative;\n\n  &.update-page {\n    min-height: calc(100vh - 56px);\n    margin-top: 56px;\n    padding: 30px 20px 20px 20px;\n  }\n\n  &.update-modal {\n    min-height: 100vh;\n  }\n}\n\n.ca-body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.ca-header {\n  background-color: $primary;\n  padding: 10px 20px;\n  border-radius: 8px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  color: white;\n}\n\n.ca-header-column {\n  display: flex;\n  flex-direction: column;\n  row-gap: 6px;\n}\n\n.view-details {\n  text-decoration: underline;\n}\n\n.ca-header-title {\n  font-size: 22px;\n  color: white;\n  font-weight: 600;\n}\n\n.ca-timing {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: 20px;\n}\n\n.ca-timing-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  column-gap: 3px;\n  color: white;\n  font-size: 13px;\n  font-family: Asap, sans-serif;\n}\n\n.ca-info {\n  width: 100%;\n  padding: 30px 20px;\n  // border-bottom: 2px solid rgba(#dbe9ef, 0.4);\n}\n\n.ca-grid {\n  width: 800px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 13px;\n}\n\n.ca-grid-item {\n  display: flex;\n  flex-direction: column;\n  color: $dark;\n}\n\n.ca-grid-item-label {\n  font-size: 13px;\n  font-family: Asap, sans-serif;\n}\n\n.ca-grid-item-text {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.ca-reason-section {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.ca-textarea-reason {\n  width: 100%;\n  padding: 5px;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  outline: none;\n}\n\n.ca-buttons-section {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ca-buttons {\n  display: flex;\n  align-items: center;\n  // justify-content: flex-end;\n  column-gap: 20px;\n}\n\n.ca-button {\n  color: white;\n\n  &:hover {\n    color: white;\n  }\n  &:focus {\n    color: white;\n  }\n}\n\n.ca-button2 {\n  background-color: $gray-500;\n}\n\n.ca-modal-main {\n  .modal-min-90 {\n    width: 500px !important;\n  }\n  .modal-min-180 {\n    width: 100vw !important;\n  }\n}\n\n.ca-exit {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  .eha-close {\n    color: $primary;\n  }\n}\n\n.cancel-exit {\n  .eha-close {\n    color: $gray-800;\n    font-size: 17px;\n  }\n}\n\n.ca-modal {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  row-gap: 20px;\n  padding: 0px 20px;\n}\n\n.ca-calendar-x {\n  position: relative;\n\n  .eha-calendar-empty {\n    font-size: 35px;\n  }\n\n  .ca-x-icon {\n    position: absolute;\n    top: 17px;\n    left: 19px;\n    color: $danger;\n  }\n}\n\n.ca-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.ca-note {\n  width: 100%;\n  text-align: center;\n}\n\n.ca-note-booking {\n  margin-bottom: 20px;\n}\n\n.update-booking-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 30px;\n}\n\n.update-booking-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 40px 0px;\n\n  background: rgba($light, 0.2);\n  box-shadow: $box-shadow-inset;\n  border: 1px solid rgba($light, 0.3);\n  border-radius: $border-radius-sm;\n\n  .title-desc {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .card-desc {\n    width: 450px;\n    text-align: center;\n    color: $gray-800;\n  }\n\n  button {\n    margin-top: 20px;\n    color: white;\n\n    &:hover {\n      color: white;\n    }\n    &:active {\n      color: white;\n    }\n  }\n}\n\n.loading-booking {\n  width: 100%;\n  height: 100vh;\n  background: url('../../../public/img/bg.jpg');\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.update-modal-main {\n  width: 100%;\n\n  .modal-xl {\n    min-width: 97% !important;\n    max-width: 97% !important;\n  }\n\n  .modal-header {\n    padding: 5px 2px;\n  }\n}\n\n.update-modal-main-body {\n  overflow-y: scroll;\n}\n\n@media screen and (max-width: 1000px) {\n  .ca-grid {\n    width: 100%;\n  }\n  .ca-note {\n    width: 100%;\n  }\n\n  .ca-modal-main {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .update-booking-card {\n    padding: 40px 10px;\n    .card-desc {\n      width: 100%;\n    }\n  }\n}\n\n@media screen and (max-width) {\n}\n\n@media screen and (max-width: 550px) {\n  .ca-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .update-booking-cards {\n    grid-template-columns: 1fr;\n    row-gap: 20px;\n  }\n\n  .ca-modal-main {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .modal-min-90 {\n      width: 340px !important;\n    }\n\n    .modal-dialog-centered {\n      margin: auto;\n    }\n  }\n\n  .ca-modal {\n    padding: 0px 10px;\n  }\n}\n",".provider-schedule-section {\n  margin-top: 50px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.provider-schedule-card {\n  border: none;\n  border-radius: $border-radius-lg;\n  background: $white;\n  box-shadow: $box-shadow;\n  position: relative;\n  padding: 20px 15px;\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.provider-schedule-title {\n  font-size: 12px;\n  flex: 1;\n}\n\n.provider-schedule-main {\n  width: 100%;\n}\n\n.provider-grid-section {\n  width: 100%;\n  padding: 20px 25px 20px 0px;\n}\n\n.header-row {\n  display: grid;\n  grid-template-columns: 2fr 10fr;\n  width: 100%;\n  max-width: 100%;\n  height: 30px;\n}\n\n.header-time-labels {\n  display: flex;\n  position: relative;\n}\n\n.header-time-label {\n  display: block;\n  font-weight: 400;\n  font-size: 11px;\n  position: absolute;\n  bottom: 0;\n}\n\n.slider-body-row {\n  display: grid;\n  grid-template-columns: 2fr 10fr;\n  width: 100%;\n  height: 45px;\n}\n\n.slider-body-cells {\n  display: grid;\n  grid-template-columns: repeat(24, 1fr);\n  padding: 0 !important;\n  position: relative;\n  z-index: 0;\n}\n\n.slider-day-switch {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n.actual-slider-day-switch {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n}\n\n.slider-day-name {\n  font-size: 11px;\n  font-weight: 400;\n  font-family: Asap, sans-serif;\n}\n\n.time-range-tag1 {\n  position: absolute;\n  bottom: 15%;\n  font-size: 12px;\n  font-weight: 400;\n  background-color: transparent;\n}\n\n.slider-body-cell {\n  border-right: 0.5px solid #ecf5f7;\n}\n\n.slider-body-cell:nth-child(3) {\n  border-left: 0.5px solid #ecf5f7;\n}\n\n.slider-body {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n}\n\n.range-slider {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  background-color: #ebeff0;\n  height: 10px;\n  align-items: center;\n}\n\n.center-slider {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.slider-unavailable {\n  font-size: 10px;\n}\n",".booking-fallback {\n  min-height: calc(100vh - 56px);\n  width: 100%;\n  background: $white url('../../../public/img/fallbackBg.jpg');\n  background-size: cover;\n  position: relative;\n}\n\n.booking-error-text {\n  position: absolute;\n  top: 18%;\n  left: 15%;\n  font-size: 220px;\n  font-weight: 600;\n  color: white;\n}\n\n.booking-error-image-footer {\n  position: absolute;\n  right: 15%;\n  top: 26%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 30px;\n  align-items: center;\n\n  div {\n    font-size: 20px;\n    color: white;\n    font-weight: 600;\n  }\n}\n\n@media screen and (max-width: 1150px) {\n  .booking-error-text {\n    font-size: 160px;\n    left: 100px;\n  }\n\n  .booking-error-image-footer {\n    right: 100px;\n\n    img {\n      width: 200px;\n    }\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .booking-fallback {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .booking-error-text {\n    position: relative;\n    font-size: 80px;\n    left: 0;\n  }\n  .booking-error-image-footer {\n    position: relative;\n    right: 0;\n    img {\n      width: 160px;\n    }\n  }\n}\n",".rtb-toolbar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0;\n}\n\n.rtb-toolbar-top {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.rtb-navigation {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.rtb-cal-btn {\n  display: flex;\n  justify-content: flex-end;\n  margin-left: auto;\n  padding: 2px;\n  color: rgb(76, 117, 121);\n}\n\n.rbc-btn {\n  margin-left: 10px !important;\n  padding: 2px 5px;\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 11px !important;\n}\n\n.rbc-btn.active {\n  background-color: #2b8ef8;\n  color: white;\n  border-radius: 8px;\n  padding: 0 15px;\n}\n\n.rtb-nav-button {\n  border: none !important;\n  background: none !important;\n  cursor: pointer;\n  font-size: 11px;\n  padding: 5px;\n  outline: none !important;\n  box-shadow: none !important;\n  color: #2b8ef8 !important;\n}\n\n.rtb-nav-icon {\n  font-size: 16px !important;\n  margin: 0 3px;\n}\n\n.rtb-toolbar-label {\n  font-weight: bold;\n  font-size: 14px;\n  padding: 0 10px;\n}\n\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.btn-save {\n  margin-left: 20px;\n}\n\n.rbc-header {\n  background: #7ec3cc2c;\n  padding: 20px !important;\n  font-size: 18px !important;\n}\n\n.rbc-allday-cell {\n  display: none;\n}\n\n.rbc-event {\n  background-color: transparent !important; \n  height: 100px;\n}\n\n.custom-event {\n  border-right: 0px !important;\n  border-left: 4px;\n  border-top: 0px !important;\n  border-bottom: 0 !important;\n  padding: 8px 8px;\n  padding-left: 6px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.shift-time {\n  font-size: 0.9rem;\n  font-weight: bold;\n  width: 100%;\n  text-align: left;\n}\n\n.shift-title {\n  font-size: 1rem;\n  font-weight: bold;\n  width: 100%;\n  text-align: left;\n}\n\n.custom-modal-size {\n  max-width: 99%;\n}\n\n.modal-title {\n  font-size: 20px;\n  margin-top: 5px;\n  color: rgba(78, 76, 76, 0.836);\n}\n\n.toggle-container {\n  border-bottom: 1px solid #7ec3cc2c;\n  padding: 8px 20px;\n  color: rgba(78, 76, 76, 0.836);\n}\n\n.toggle-button {\n  justify-content: left;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.toggle {\n  background-color: #2b8ef8;\n  height: 9px;\n  width: 20px;\n  border-radius: 30px;\n  display: flex;\n}\n\n.toggle-active {\n  background-color: rgba(98, 133, 136, 0.836);\n}\n\n.toggle-left {\n  height: 7px;\n  width: 5px;\n  background-color: white;\n  border-radius: 20px;\n  margin: 1.5px 2px;\n}\n\n.toggle-right {\n  height: 7px;\n  width: 5px;\n  background-color: white;\n  border-radius: 20px;\n  margin: 1px 0.5px 2px 12.5px;\n}\n\n.toggle-button2 {\n  justify-content: left;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n.toggle2 {\n  background-color: #2b8ef8;\n  height: 9px;\n  width: 20px;\n  border-radius: 30px;\n  display: flex;\n}\n\n.toggle-left2 {\n  height: 7px;\n  width: 5px;\n  background-color: white;\n  border-radius: 20px;\n  margin: 1px 2px;\n}\n\n.toggle-right2 {\n  height: 7px;\n  width: 5px;\n  background-color: white;\n  border-radius: 20px;\n  margin: 1px 0.5px 2px 12.5px;\n}\n\n.toggle-active2 {\n  background-color: rgba(98, 133, 136, 0.836);\n}\n\n.menu-container {\n  position: fixed;\n  background-color: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-in-out;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.menu-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  border-bottom: 1px solid #ddd;\n}\n\n.selected-date {\n  font-size: 14px;\n  font-weight: bold;\n  color: #333;\n}\n\n.close-menu {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: transparent;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.close-menu:hover {\n  color: #ff0000;\n}\n\nselect {\n  width: 100%;\n  padding: 6px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: #f9f9f9;\n  font-size: 14px;\n}\n\n.hidden-day {\n  display: none !important;\n}\n\n.all-day-label input {\n  margin-right: 4px; \n}\n\n.bold-text {\n  font-weight: bold;\n  font-size: 16px;\n  color: #415EBC;\n}\n\n.cancel-button {\n  border-color: #415EBC;\n  color: #415EBC;\n}",".booking-header {\n    padding: 4px 20px 12px 24px;            \n}\n\n.booking-divider {\n    height: 1px;\n    background-color: #e7f0f2;    \n  }\n  ",".client-table-appointment {\n  //   background: $white url('/img/bg.jpg');\n  //   background-size: cover;\n  //   min-height: calc(100vh - $topnav-height);\n\n  // Style for centering alert element\n  //   display: flex;\n  //   flex-direction: column;\n\n  // Style for centering alert element\n  .center-alert {\n    height: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n  }\n\n  // Style for centering alert element\n  .center-search {\n    position: absolute;\n    width: 100%;\n    top: 55%;\n  }\n\n  /////\n  // .eha-table {\n  //   width: 100%;\n\n  //   thead,\n  //   tbody {\n  //     width: 100%;\n  //   }\n\n  //   thead,\n  //   tbody,\n  //   th,\n  //   td {\n  //     display: block;\n  //   }\n\n  //   thead tr,\n  //   tbody tr {\n  //     display: grid;\n  //     // grid-template-columns: 1fr 6rem 6rem 9rem 11rem 1fr 10rem 8rem 5.5rem;\n  //     grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n  //   }\n\n  //   th,\n  //   td {\n  //     white-space: nowrap;\n  //     overflow: hidden;\n  //   }\n\n  //   td:not(:last-child) {\n  //     text-overflow: ellipsis;\n  //   }\n\n  //   td.name {\n  //     font-weight: 600;\n  //   }\n  // }\n\n  // @media screen and (min-width: 768px) and (max-width: 1024px) {\n  //   .eha-table {\n  //     .last-visit,\n  //     .patient-id {\n  //       display: none;\n  //     }\n\n  //     thead tr,\n  //     tbody tr {\n  //       grid-template-columns: 2fr 6rem 6rem 9rem 10rem 5rem;\n  //     }\n\n  //     th,\n  //     td {\n  //       padding: 0.7rem 0.2rem 0.5rem;\n  //     }\n  //   }\n  // }\n\n  // @media screen and (max-width: 768px) {\n  //   .eha-table {\n  //     thead {\n  //       .status,\n  //       .phone,\n  //       .gender,\n  //       .dob,\n  //       .membership,\n  //       .patient-id {\n  //         display: none;\n  //       }\n  //     }\n\n  //     thead tr {\n  //       display: block;\n\n  //       th {\n  //         display: inline-block;\n  //       }\n  //     }\n\n  //     tbody tr {\n  //       display: flex;\n  //       flex-wrap: wrap;\n  //       align-items: baseline;\n  //       padding: 1rem;\n  //       margin-top: 8px;\n  //       position: relative;\n  //     }\n\n  //     td {\n  //       width: 50%;\n  //       padding: 0;\n  //     }\n\n  //     td.name {\n  //       font-weight: 600;\n  //       font-size: 1.2rem;\n  //       padding-bottom: 0.5rem;\n  //     }\n\n  //     td.gender,\n  //     td.age,\n  //     td.membership,\n  //     td.status {\n  //       width: auto;\n  //     }\n\n  //     td.gender {\n  //       margin-left: auto;\n  //     }\n\n  //     td.age {\n  //       &::before {\n  //         content: ', ';\n  //       }\n  //     }\n\n  //     td.status {\n  //       position: absolute;\n  //       bottom: 1rem;\n  //       right: 1rem;\n  //     }\n\n  //     td.dob,\n  //     td.last-visit,\n  //     td.patient-id,\n  //     td.phone,\n  //     td.membership {\n  //       padding-right: 1rem;\n  //       min-width: 300px;\n\n  //       &::before {\n  //         content: attr(title);\n  //         display: inline-block;\n  //         width: 7rem;\n  //         font-family: Asap, sans-serif;\n  //         font-weight: 400;\n  //         font-style: italic;\n  //         font-size: 13px;\n  //       }\n  //     }\n  //   }\n  // }\n}\n\n.collapsible-filterbar {\n  background: rgba($body-color, 0.1);\n  box-shadow: $box-shadow-inset;\n  border: 1px solid rgba($body-color, 0.1);\n  flex: 1;\n  border-radius: 1.8rem;\n\n  .filters-top {\n    color: $white;\n  }\n\n  .filterbar-toggle {\n    width: 4rem;\n    margin-left: 1px;\n    cursor: pointer;\n    border-top-right-radius: 1.8rem;\n\n    &:hover {\n      background: rgba($secondary, 0.2);\n    }\n  }\n\n  .filterbar-search {\n    input {\n      background: none;\n      border: 0;\n      color: $white;\n      flex: 1;\n      padding-right: 1.6rem;\n\n      &:focus,\n      &:focus-visible,\n      &:active,\n      &:hover {\n        background: none;\n        border: 0;\n        outline: 0;\n      }\n    }\n\n    input::placeholder {\n      color: rgba($white, 0.5);\n    }\n\n    // @include media-breakpoint-down(sm) {\n    //   width: 100%;\n    //   border-bottom: 1px solid $purple;\n    // }\n  }\n\n  .filters-expand {\n    background: rgba($body-color, 0.1);\n    border-bottom-right-radius: 1.8rem;\n    border-bottom-left-radius: 1.8rem;\n  }\n\n  &.collapsed {\n    .filters-expand {\n      display: none;\n    }\n\n    .filterbar-toggle {\n      border-bottom-right-radius: 1.8rem;\n    }\n  }\n}\n\n.filter-badge {\n  font-size: 0.9rem;\n  color: $light;\n  border-radius: $border-radius-sm;\n  /* stylelint-disable */\n  background: lighten($purple, 3);\n  /* stylelint-enable */\n  padding: 0.1rem 0.8rem;\n  margin: 0.1rem 0 0.1rem 0.6rem;\n}\n\n.input-switch {\n  position: relative;\n  align-items: center;\n  flex: 1;\n}\n\n.filter-reset-value {\n  opacity: 0.4;\n  position: absolute;\n  right: 1.6rem;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.search-menu {\n  .search-toggle {\n    color: $white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
